import {
  CellClassParams,
  GridApi,
  GridOptions,
  RowSelectedEvent,
  ValueGetterParams,
} from "ag-grid-community";
import ServerSideDatasource from "./GridViewDataSource";
// import AccountNameRenderer from "components/portfolio/cellRenderer/AccountNameRenderer";
import { AxiosInstance } from "axios";
import ProductRenderer from "components/activity/cellRenderer/ProductRenderer";
import ComonAccountNameRender from "components/app/ComonAccountNameRender";
import HighlightFilterModelCellRenderer from "components/app/HighlightFilterModelCellRenderer";
import RadioFilter from "components/dashboard/enterprise/customerFilters/RadioFilter";
import EscalationRenderer from "components/dashboard/executive/cellRenderer/EscalationRenderer";
import SubscriptionRenderer, {
  SubscriptionType,
} from "components/dashboard/executive/cellRenderer/SubscriptionRenderer";
import PercentFilter from "components/dashboard/executive/filters/PercentFilter";
import WorkloadFilter from "components/dashboard/executive/filters/WorkloadFilter";
import SaveSearchPanel from "components/portfolio/SaveSearchPanel";
import CCSECellEditor from "components/portfolio/cellEditor/CCSECellEditor";
import CallingEpsmCellEditor from "components/portfolio/cellEditor/CallingEpsmCellEditor";
import AccountIdRenderer from "components/portfolio/cellRenderer/AccountIdRenderer";
import AccountTypeRenderer from "components/portfolio/cellRenderer/AccountTypeRenderer";
import ActivityAlreadyRenderer from "components/portfolio/cellRenderer/ActivityAlreadyRenderer";
import AlertRenderer from "components/portfolio/cellRenderer/AlertRenderer";
import AnchorProductRenderer from "components/portfolio/cellRenderer/AnchorProductRenderer";
import BetaProgramRenderer from "components/portfolio/cellRenderer/BetaProgramRenderer";
import CIOrganizationIDRenderer from "components/portfolio/cellRenderer/CIOrganizationIDRenderer";
import ChConfigStatusRenderer from "components/portfolio/cellRenderer/ChConfigStatusRenderer";
import CollabMapRenderer from "components/portfolio/cellRenderer/CollabMapRenderer";
import CollectionRevenueCellHeader from "components/portfolio/cellRenderer/CollectionRevenueCellHeader";
import CollectionRevenueCellRenderer from "components/portfolio/cellRenderer/CollectionRevenueCellRenderer";
import CompetitorRenderer from "components/portfolio/cellRenderer/CompetitorRenderer";
import ConciergeRenderer from "components/portfolio/cellRenderer/ConciergeRenderer";
import ContactsRenderer from "components/portfolio/cellRenderer/ContactsRenderer";
import CountryRenderer from "components/portfolio/cellRenderer/CountryRenderer";
import CoverageStatusRenderer from "components/portfolio/cellRenderer/CoverageStatusRenderer";
import CustomTooltipHeader from "components/portfolio/cellRenderer/CustomTooltipHeader";
import EditableCellRenderer from "components/portfolio/cellRenderer/EditableCellRenderer";
import ExpandPlanRenderer from "components/portfolio/cellRenderer/ExpandPlanRenderer";
import HealthScoreRenderer from "components/portfolio/cellRenderer/HealthScoreRenderer";
import InvoiceMrrArrRenderer from "components/portfolio/cellRenderer/InvoiceMrrArrRenderer";
import OrganizationInvoiceArrCellRenderer from "components/portfolio/cellRenderer/OrganizationInvoiceArrCellRenderer";
import QVRRenderer from "components/portfolio/cellRenderer/QVRRenderer";
import SiteURLsRenderer from "components/portfolio/cellRenderer/SiteURLsRenderer";
import StaticCollectionRevenueCellRenderer from "components/portfolio/cellRenderer/StaticCollectionRevenueCellRenderer";
import TagsRenderer from "components/portfolio/cellRenderer/TagsRenderer";
import BetaProgramFilter from "components/portfolio/customerFilters/BetaProgramFilter";
import CheckboxFilter from "components/portfolio/customerFilters/CheckboxFilter";
import CheckboxTreeFilter from "components/portfolio/customerFilters/CheckboxTreeFilter";
import CollabMapFilter from "components/portfolio/customerFilters/CollabMapFilter";
import ConciergeFilter from "components/portfolio/customerFilters/ConciergeFilter";
import DatePickerFilter from "components/portfolio/customerFilters/DatePickerFilter";
import ExpandPlanFilter from "components/portfolio/customerFilters/ExpandPlanFilter";
import NumberFilter from "components/portfolio/customerFilters/NumberFilter";
import PartnerAccountNameFilter from "components/portfolio/customerFilters/PartnerAccountNameFilter";
import ProductServiceFilter from "components/portfolio/customerFilters/ProductServiceFilter";
import QuaterViewReviewFilter from "components/portfolio/customerFilters/QuaterViewReviewFilter";
import ResellerFilter from "components/portfolio/customerFilters/ResellerFilter";
import { FlagEnum, getFlagCode, isFlag } from "components/portfolio/utils";
import {
  AOV_CLOUD_COLLECTION_COLUMN,
  AOV_COLLAB_COLLECTION_COLUMN,
  AOV_COLLECTION_COLUMN,
  AOV_ONPREM_COLLECTION_COLUMN,
  BREAK_UP_AOV_CLOUD_CONTACT_CENTER_COLUMN,
  BREAK_UP_CLOUD_CONTACT_CENTER_COLUMN,
  CLOUD_COLLECTION_COLUMN,
  COLLAB_COLLECTION_COLUMN,
  COLLECTION_COLUMN,
  FEATURE_KEY,
  FEATURE_TOGGLES,
  NON_COLLAB_COLLECTION_COLUMN,
  ONPREM_COLLECTION_COLUMN,
  // PAGE_SIZE,
  // PORTFOLIO_COLUMN_STATE_KEY,
  PORTFOLIO_LAST_SEARCH_KEY,
  PORTFOLIO_LAST_SORT_KEY,
  PRE_SELECTED_ACCOUNT,
  RANK_VALUE_LIST,
  ROLE,
  ROW_HEADER_HEIGHT,
  ROW_HEIGHT,
  SUIT_AOV_COLLECTION_COLUMN,
  SUIT_COLLECTION_COLUMN,
} from "constant";
import { customInvoiceARRTip, TOOLTIP } from "constant/header-tip";
import { numberFormat } from "highcharts";
import moment from "moment";
import "moment-timezone";
import { toast } from "react-toastify";
import { GirdColumnDef, Matadata } from "types/app";
import { AuthDetail } from "types/auth";
import { Account, CallingPsmMetadata, CCSEMetadata } from "types/portfolio";
import { ExpandPlanTypeEnum, SelectAccount } from "types/summary";
import {
  amountVisibleCheck,
  currencyFormatter,
  dispatchCustomEvent,
  getContextMenu,
  getMainMenuItems,
  handleAdoptionPercent,
  handleAgGridFilterIcon,
  handleFFHorizontalScrollbar,
  joinByKey,
  processFilterFromURL,
  savingColumnState,
} from "utils";
import AROffPendingCancelRenderer from "components/portfolio/cellRenderer/AROffPendingCancelRenderer";
import CheckboxCellRenderer, {
  getCheckboxContextMenu,
} from "components/portfolio/cellRenderer/CheckboxCellRenderer";
import GroupRenderer from "components/portfolio/cellRenderer/GroupRenderer";
import ReasonRenderer from "components/portfolio/cellRenderer/ReasonRenderer";
import WSMPStatusRenderer from "components/portfolio/cellRenderer/WSMPStatusRenderer";
import CheckboxHeader from "components/portfolio/components/CheckboxHeader";
import NoRowsOverlayComponent from "components/portfolio/components/NoRowsOverlayComponent";
import DeviceFilter from "components/portfolio/customerFilters/DeviceFilter";
import styles from "components/portfolio/portfolio.module.scss";

export const invoiceTooltip = `
<ul style="margin-top:8px">
  <li style="line-height: 16px;">Offer Attribution: It is a set of end-to-end processes and capabilities (quoting, ordering, finance, reporting, and sales comp) to enable proper allocation of bookings, revenue, and associated compensation between business entities and service organizations</li>
  <li style="line-height: 16px;margin-top:8px">Adjustment = Discount</li>
</ul>
`;

const healthTip = `<div>
<p>The Health Score listed here is: </p>
<p>1.the score of the primary Webex site URL under an account</p>
<p>2.Case when no sites associated to an account, then the score is associated to the Control Hub (CH) Organization ID linked to the account</p>
<p>3.Case when multiple Control Hub Organization ID's are linked to one account, then the score is of the CH Org ID that maps to a subscription having the highest Annual Recurring Revenue (ARR).</p>
<p>A primary site is the one with highest count of 'Active' users in last 30 days.</p>
<p>To view the score of other sites or CH Org IDs associated to the account, select 'Show All' under 'Site URLs' or 'Control Hub Organization ID' column or view them on the 'Details' page under 'Sites' section. The score is derived considering following contributory scores:</p>
<p>- Org Settings Score</p>
<p>- User Management Score</p>
<p>- Integration Score</p>
<p>
  - Meetings (Usage and Adoption Score, Join Meeting Time Score, In Meeting
  Score)
</p>
<p>- Rooms (Usage and Adoption Score, Quality Score)</p>
<p>- Messaging (Usage and Adoption Score)</p>
<p>- Calling (Usage and Adoption Score)</p>
</div>`;

const Config = (
  axios: AxiosInstance,
  setGridEvent: any,
  authDetail: AuthDetail,
  ccse: CCSEMetadata[],
  callingEpsm: CallingPsmMetadata[],
  callingPsm: CallingPsmMetadata[],
  eventMappings: Matadata[],
  workloadCategory: Matadata[],
  workloadStage: Matadata[],
  embedded: boolean,
  setCollectionColumns: React.Dispatch<React.SetStateAction<string[]>>,
  setAOVCollectionColumns: React.Dispatch<React.SetStateAction<string[]>>,
  groupCol: string,
  setExpandedGroups?: any,
  cavBuId?: number,
  ciscoCsmId?: string,
  fixedAccountId?: string,
  // mutate?: () => Promise<void>,
  setTotalSelect?: React.Dispatch<React.SetStateAction<SelectAccount[]>>,
  preSelected?: string[],
  showAOV?: boolean
): GridOptions & { groupHeader?: string; subGroupHeader?: string } => {
  const factorMappings: { [key: string]: string } = (eventMappings ?? []).reduce(
    (obj, item) => {
      obj[item.code] = item.value;
      return obj;
    },
    {} as { [key: string]: string }
  );

  const columnDef: GirdColumnDef[] = [
    {
      colId: "externalCheckbox",
      toolPanelClass: ["column_disabled"],
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: false,
      checkboxSelection: true,
      maxWidth: 75,
      width: 75,
      pinned: "left",
      lockPinned: true,
      lockPosition: true,
      lockVisible: true,
      suppressMovable: true,
      suppressMenu: true,
      sortable: false,
      headerComponent: "CheckboxHeader",
      cellRendererParams: {
        hideMenu: embedded,
      },
      headerName: "externalCheckbox",
      cellRenderer: "CheckboxCellRenderer",
      // authDetail.features.includes(
      //   FEATURE_KEY.PORTFOLIO_ACCOUNT_TEAM
      // )
      //   ? "CheckboxCellRenderer"
      //   : "",
      cellClass: ["checkbox_cell"],
    },
    {
      colId: "externalFilter",
      toolPanelClass: ["column_disabled"],
      filter: "agTextColumnFilter",
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      headerName: "Quick Filter",
    },
    {
      colId: "externalKeyword",
      toolPanelClass: ["column_disabled"],
      filter: "agTextColumnFilter",
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      headerName: "Keyword",
    },
    {
      colId: "externalAlertFilter",
      toolPanelClass: ["column_disabled"],
      filter: "agTextColumnFilter",
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      headerName: "Quick Alert Filter",
    },
    {
      colId: "externalSearch",
      // toolPanelClass: ["column_disabled"],
      filter: "agTextColumnFilter",
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      headerName: "externalSearch",
    },
    {
      colId: "externalQuery",
      // toolPanelClass: ["column_disabled"],
      filter: "agTextColumnFilter",
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      headerName: "externalQuery",
    },
    {
      colId: "cgemFlag",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "CGEM",
    },
    {
      colId: `banner_${getFlagCode(FlagEnum.BigFish)}`,
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: false,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Big Fish",
    },
    {
      colId: `banner_${getFlagCode(FlagEnum.LittleFish)}`,
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: false,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Little Fish",
    },
    {
      colId: `banner_${getFlagCode(FlagEnum.DedicatedInstance)}`,
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: false,
      suppressFiltersToolPanel: false,
      hide: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Dedicated Instance",
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return isFlag(params.data?.bannerFlag, FlagEnum.DedicatedInstance) ? "Yes" : "No";
      },
    },
    {
      colId: "wholesaleFlag",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Wholesale Partner",
    },
    {
      colId: `banner_${getFlagCode(FlagEnum.WpaFlag)}`,
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: false,
      hide: true,
      lockVisible: true,
      groupHeader: "Customer",
      toolPanelClass: ["skip_visiable_check"],
      headerName: "WPA",
    },
    {
      colId: "priorityIndicatorRank",
      filter: "agTextColumnFilter",
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      headerName: "priorityIndicatorRank",
    },
    {
      headerName: "Alerts",
      field: "externalAlertColumn",
      colId: "externalAlertColumn",
      hide: true,
      sortable: false,
      filter: "CheckboxTreeFilter",
      filterParams: {
        queryParams: "alerts",
        axios,
        authDetail,
      },
      pinned: "left",
      minWidth: 144,
      suppressFiltersToolPanel: false,
      // suppressColumnsToolPanel: true,
      lockVisible: true,
      lockPinned: true,
      lockPosition: true,
      exclude: !authDetail.features.includes(FEATURE_KEY.ALERT),
      cellRenderer: "AlertRenderer",
    },
    {
      headerName: "Account ID",
      field: "accountId",
      colId: "accountId",
      lockPinned: true,
      lockPosition: true,
      lockVisible: true,
      suppressMovable: true,
      pinned: "left",
      toolPanelClass: ["column_disabled"],
      cellRenderer: "AccountIdRenderer",
      headerClass: ["accountIdCell"],
      headerComponentParams: {
        template: `
        <div class="ag-cell-label-container" role="presentation">
          <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
          <div ref="eLabel" class="ag-header-cell-label" role="presentation" style="padding-left:8px;">
            <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>
            <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
            <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
            <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
            <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
            <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
          </div>
      </div>
        `,
      },
      cellClass: (params: CellClassParams) =>
        params.data?.lifecyclePartnerFlag ? "cell_lcm_indicator" : "",
      groupHeader: "Customer",
    },
    {
      headerName: "Account Name",
      field: "accountName",
      colId: "accountName",
      width: 345,
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["contains"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      cellRenderer: "ComonAccountNameRender",
      cellRendererParams: {
        openNew: embedded,
      },
      cellClass: ["account-name-cell"],
      suppressMovable: true,
      lockPinned: true,
      lockPosition: true,
      lockVisible: true,
      pinned: "left",
      toolPanelClass: ["column_disabled"],
      groupHeader: "Customer",
      cellStyle: { "border-right-color": "#e2e2e2" },
    },
    {
      headerName: "Beta Program Participation",
      colId: "bpp",
      field: "bpp",
      sortable: true,
      filter: "BetaProgramFilter",
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.bpp;
      },
      cellRenderer: "BetaProgramRenderer",
      headerTooltip: `<p>At least one customer user/contact has signed up for a Webex Beta Program. Excludes those who have stopped participating.</p>`,
    },
    {
      headerName: "CAV ID",
      field: "cavId",
      colId: "cavId",
      cellRenderer: "HighlightFilterModelCellRenderer",
      groupHeader: "Customer",
      headerTooltip: `<p>The CAV ID is associated to the customer level that represents the global view of the Customer from Cisco's lens.</p>
                     <br/>
                     <p>About Customer Account View (CAV) - it is created by Cisco's Customer Experience (CX) to drive how we connect, support, and track customers through the Cisco adoption lifecycle. And to facilitate how we segment customers for the prioritization of CX resources for customer engagement.</p>
                     `,
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["contains"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      valueGetter: (params) => {
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.cavId ?? "";
      },
    },
    {
      headerName: "CAV Name",
      field: "cavName",
      colId: "cavName",
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["contains"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      cellRenderer: "HighlightFilterModelCellRenderer",
      groupHeader: "Customer",
      headerTooltip: `<p>The CAV Name is associated to the customer level that represents the global view of the Customer from Cisco's lens.</p>
                     <br/>
                     <p>About Customer Account View (CAV) - it is created by Cisco's Customer Experience (CX) to drive how we connect, support, and track customers through the Cisco adoption lifecycle. And to facilitate how we segment customers for the prioritization of CX resources for customer engagement.</p>
                     `,
    },
    {
      headerName: "CAV Business Unit ID",
      field: "cavBuId",
      colId: "cavBuId",
      cellRenderer: "HighlightFilterModelCellRenderer",
      groupHeader: "Customer",
      headerTooltip: `<p>Under the global view of the customer represented by the CAV ID or CAV Name, customers are further divided into Business Units (BUs), representing operating country (private sector) or departments (public sector).</p>
                       <br/>
                     <p>About Customer Account View (CAV) - it is created by Cisco's Customer Experience (CX) to drive how we connect, support, and track customers through the Cisco adoption lifecycle. And to facilitate how we segment customers for the prioritization of CX resources for customer engagement.</p>
                     `,
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["contains"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      valueGetter: (params) => {
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.cavBuId ?? "";
      },
    },
    {
      headerName: "CAV Business Unit Name",
      field: "cavBuName",
      colId: "cavBuName",
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["contains"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      cellRenderer: "HighlightFilterModelCellRenderer",
      groupHeader: "Customer",
      headerTooltip: `<p>Under the global view of the customer represented by the CAV ID or CAV Name, customers are further divided into Business Units (BUs), representing operating country (private sector) or departments (public sector).</p>
                     <br/>
                     <p>About Customer Account View (CAV) - it is created by Cisco's Customer Experience (CX) to drive how we connect, support, and track customers through the Cisco adoption lifecycle. And to facilitate how we segment customers for the prioritization of CX resources for customer engagement.</p>
                     `,
    },
    {
      headerName: "Custom Invoice ARR/Bookings",
      field: "invoiceArrCustom",
      colId: "invoiceArrCustom",
      authKey: "invoiceArrMeetingMsgOnPrem",
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      cellRenderer: "CollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: COLLECTION_COLUMN,
      },
      groupHeader: "Invoice ARR",
      groupIndex: 10,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      headerComponent: "CollectionRevenueCellHeader",
      headerComponentParams: {
        collection: COLLECTION_COLUMN,
        headerTooltip: customInvoiceARRTip,
      },
      enableCellChangeFlash: false,
      headerClass: "ag-react-container-full-width ",
    },
    {
      headerName: "Invoice ARR (Cloud Meetings + Messaging)",
      field: "invoiceArrMeetingMsgCloud",
      colId: "invoiceArrMeetingMsgCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrMeetingMsgCloud = 0 } = params.data;
          return `$${invoiceArrMeetingMsgCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrMeetingMsgCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (On-Prem Meetings + Messaging)",
      field: "invoiceArrMeetingMsgOnPrem",
      colId: "invoiceArrMeetingMsgOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrMeetingMsgOnPrem = 0 } = params.data;
          return `$${invoiceArrMeetingMsgOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        const data: Account | null = params.data;
        if (data?.invoiceMrrCalling) {
          return currencyFormatter(data?.invoiceMrrCalling);
        }
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (Cloud Calling)",
      field: "invoiceArrCallingCloud",
      colId: "invoiceArrCallingCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrCallingCloud = 0 } = params.data;
          return `$${invoiceArrCallingCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrCallingCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (On-Prem Calling)",
      field: "invoiceArrCallingOnPrem",
      colId: "invoiceArrCallingOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrCallingOnPrem = 0 } = params.data;
          return `$${invoiceArrCallingOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrCallingOnPrem);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (Cloud Contact Center)",
      field: "invoiceArrContactCenterCloud",
      colId: "invoiceArrContactCenterCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrContactCenterCloud = 0 } = params.data;
          return `$${invoiceArrContactCenterCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrContactCenterCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (Webex Contact Center)",
      field: "invoiceArrCloudWXCC",
      colId: "invoiceArrCloudWXCC",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      sortable: true,
      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { invoiceArrCloudWXCC = 0 } = params.data;
          return `$${invoiceArrCloudWXCC?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrCloudWXCC);
      },
      // toolPanelClass: ["skip_visiable_check"],
      subGroupHead: "Invoice ARR (Cloud Contact Center)",
      groupHeader: "Invoice ARR",
      groupIndex: 5,
    },
    {
      headerName: "Invoice ARR (Webex Contact Center Enterprise)",
      field: "invoiceArrCloudWXCCE",
      colId: "invoiceArrCloudWXCCE",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrContactCenterEnterprise = 0 } = params.data;
          return `$${invoiceArrContactCenterEnterprise?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrContactCenterEnterprise);
      },
      toolPanelClass: ["skip_visiable_check"],
      subGroupHeader: "Invoice ARR (Cloud Contact Center)",
    },
    {
      headerName: "Invoice ARR (Webex Contact Center Add-Ons)",
      field: "invoiceArrCloudWXCCAddon",
      colId: "invoiceArrCloudWXCCAddon",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrCloudWXCCAddon = 0 } = params.data;
          return `$${invoiceArrCloudWXCCAddon?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrCloudWXCCAddon);
      },
      toolPanelClass: ["skip_visiable_check"],
      subGroupHeader: "Invoice ARR (Cloud Contact Center)",
    },
    {
      headerName: "Invoice ARR (Webex Contact Center Digital Channels)",
      field: "invoiceArrCloudWXCCDC",
      colId: "invoiceArrCloudWXCCDC",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrCloudWXCCDC = 0 } = params.data;
          return `$${invoiceArrCloudWXCCDC?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrCloudWXCCDC);
      },
      toolPanelClass: ["skip_visiable_check"],
      subGroupHeader: "Invoice ARR (Cloud Contact Center)",
    },
    {
      headerName: "Invoice ARR (On-Prem Contact Center)",
      field: "invoiceArrContactCenterOnPrem",
      colId: "invoiceArrContactCenterOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrContactCenterOnPrem = 0 } = params.data;
          return `$${invoiceArrContactCenterOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrContactCenterOnPrem);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (Cloud Devices)",
      field: "invoiceArrDeviceCloud",
      colId: "invoiceArrDeviceCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrDeviceCloud = 0 } = params.data;
          return `$${invoiceArrDeviceCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrDeviceCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (On-Prem Devices)",
      field: "invoiceArrDeviceOnPrem",
      colId: "invoiceArrDeviceOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrDeviceOnPrem = 0 } = params.data;
          return `$${invoiceArrDeviceOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrDeviceOnPrem);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    // Webex Suite Starts
    {
      headerName: "Invoice ARR (Webex Suite)",
      field: "invoiceArrSuiteCustom",
      colId: "invoiceArrSuiteCustom",
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      groupHeader: "Invoice ARR",
      groupIndex: 20,
      // minWidth: 265,
      // width: 265,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: { collection: SUIT_COLLECTION_COLUMN },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrSuiteCustom = 0 } = params.data;
          return `$${invoiceArrSuiteCustom?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrSuiteCustom);
      },
      headerTooltip: `<p style="line-height: 16px;font-size:12px">Sum of ARR of all the post offer attribution and post adjustment annual recurring revenue (ARR) of all products except Technical Support that are part of the Webex Suite offer under a given subscription.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                <div class="ag-cell-label-container" role="presentation">
                  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                  <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                    <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                  </div>
                  <div style="position: absolute;
                  bottom: 6px;
                  left: 25px;
                  color: #00A0D1;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-size: 9px;">Webex Suite (Excludes Technical Support)<div>
              </div>
              </div>
                `,
      },
    },
    {
      headerName: "Invoice ARR Suite (Cloud Meetings + Messaging)",
      field: "invoiceArrSuiteMeetingCloud",
      colId: "invoiceArrSuiteMeetingCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrSuiteMeetingCloud = 0 } = params.data;
          return `$${invoiceArrSuiteMeetingCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrSuiteMeetingCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR Suite (Cloud Calling)",
      field: "invoiceArrSuiteCallingCloud",
      colId: "invoiceArrSuiteCallingCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrSuiteCallingCloud = 0 } = params.data;
          return `$${invoiceArrSuiteCallingCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrSuiteCallingCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    // {
    //   headerName: "Invoice ARR Suite (On-Prem Meetings + Messaging)",
    //   field: "invoiceArrSuiteMeetingOnPrem",
    //   colId: "invoiceArrSuiteMeetingOnPrem",
    //   filter: false,
    //   hide: true,
    //   suppressColumnsToolPanel: true,
    //   suppressFiltersToolPanel: true,
    //   lockVisible: true,
    //   sortable: false,
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       const { invoiceArrSuiteMeetingOnPrem = 0 } = params.data;
    //       return `$${invoiceArrSuiteMeetingOnPrem?.toLocaleString("en-US", {
    //         minimumFractionDigits: 2,
    //         maximumFractionDigits: 2,
    //       })}`;
    //     }
    //     return currencyFormatter(params.data?.invoiceArrSuiteMeetingOnPrem);
    //   },
    //   toolPanelClass: ["skip_visiable_check"],
    // },
    {
      headerName: "Invoice ARR Suite (On-Prem Calling)",
      field: "invoiceArrSuiteCallingOnPrem",
      colId: "invoiceArrSuiteCallingOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrSuiteCallingOnPrem = 0 } = params.data;
          return `$${invoiceArrSuiteCallingOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.invoiceArrSuiteCallingOnPrem);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    // Webex Suite Ends
    {
      headerName: "Invoice ARR (Collab + Non-Collab)",
      groupHeader: "Invoice ARR",
      groupIndex: 8,
      field: "invoiceArrTotal",
      colId: "invoiceArrTotal",
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "InvoiceMrrArrRenderer",
      cellRendererParams: {
        type: "invoiceArr",
        label: "ARR",
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrTotal = 0 } = params.data;
          return invoiceArrTotal;
        }
        const data: Account | null = params.data;
        return data?.invoiceArrTotal;
      },
      headerTooltip: `<p style="line-height: 16px;font-size:12px">Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of products or services (SKU) under a given subscription that are considered as 'Collaboration' and 'Non-Collaboration' revenue by Cisco Finance. Security and Technical Support Services is <b>not</b> considered as 'Collaboration' recurring revenue.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
              <div class="ag-cell-label-container" role="presentation">
                <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                  <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                  <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                  <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                  <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                  <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                </div>
                <div style="position: absolute;
                bottom: 6px;
                left: 25px;
                color: #00A0D1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 9px;
                width: -webkit-fill-available;">(Collab + Non-Collab)<div>
            </div>
            </div>
              `,
      },
    },
    {
      headerName: "Invoice ARR (Collab)",
      field: "invoiceArrCollab",
      colId: "invoiceArrCollab",
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      groupHeader: "Invoice ARR",
      groupIndex: 6,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [...COLLAB_COLLECTION_COLUMN, ...BREAK_UP_CLOUD_CONTACT_CENTER_COLUMN],
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrCollab = 0 } = params.data;
          return invoiceArrCollab;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.invoiceArrCollab ?? 0);
      },
      headerTooltip: `<p style="line-height: 16px;font-size:12px"> Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of products (SKU) under a given subscription that are considered as 'Collaboration' revenue by Cisco Finance.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                <div class="ag-cell-label-container" role="presentation">
                  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                  <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                    <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                  </div>
                  <div style="position: absolute;
                  bottom: 6px;
                  left: 25px;
                  color: #00A0D1;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-size: 9px;">(Collab)<div>
              </div>
              </div>
                `,
      },
    },
    {
      headerName: "Invoice ARR (Non-Collab)",
      field: "invoiceArrNonCollab",
      colId: "invoiceArrNonCollab",
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      groupHeader: "Invoice ARR",
      groupIndex: 7,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: { collection: NON_COLLAB_COLLECTION_COLUMN },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrNonCollab = 0 } = params.data;
          return invoiceArrNonCollab;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.invoiceArrNonCollab ?? 0);
      },
      headerTooltip: `<p style="line-height: 16px;font-size:12px">Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of products or services (SKU) under a given subscription that are not considered as 'Collaboration' revenue by Cisco Finance. Security and Technical Support Service is <b>not</b> considered as 'collaboration' recurring revenue.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                  <div class="ag-cell-label-container" role="presentation">
                    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                      <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                      <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                      <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                      <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                      <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                      <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                    </div>
                    <div style="position: absolute;
                    bottom: 6px;
                    left: 25px;
                    color: #00A0D1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 9px;">(Non-Collab)<div>
                </div>
                </div>
                  `,
      },
    },
    {
      headerName: "Invoice ARR (On-Prem + Cloud)",
      field: "invoiceArrOnPremAndCloud",
      colId: "invoiceArrOnPremAndCloud",
      authKey: "invoiceArrOnPrem",
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [
          ...ONPREM_COLLECTION_COLUMN,
          ...CLOUD_COLLECTION_COLUMN,
          ...BREAK_UP_CLOUD_CONTACT_CENTER_COLUMN,
        ],
      },
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      groupHeader: "Invoice ARR",
      groupIndex: 5,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrOnPremAndCloud = 0 } = params.data;
          return invoiceArrOnPremAndCloud;
        }
        const data: Account | null = params.data;

        return currencyFormatter((data?.invoiceArrOnPrem || 0) + (data?.invoiceArrCloud || 0));
      },
      headerTooltip: `<p style="line-height: 16px;font-size: 12px">Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of 'on-premises' and 'cloud' products (SKU) under a given subscription.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                      <div class="ag-cell-label-container" role="presentation">
                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                          <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                          <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                          <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                          <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                          <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                          <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                        </div>
                        <div style="position: absolute;
                        bottom: 6px;
                        left: 25px;
                        color: #00A0D1;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 9px;">(On-Prem + Cloud)<div>
                    </div>
                    </div>
                      `,
      },
    },
    {
      headerName: "Invoice ARR (On-Prem + Cloud - CPAAS)",
      field: "invoiceArrNoCPass",
      colId: "invoiceArrNoCPass",
      authKey: "invoiceArrOnPrem",
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [
          ...ONPREM_COLLECTION_COLUMN,
          ...CLOUD_COLLECTION_COLUMN.filter((c) => c !== "invoiceArrCPassCloud"),
          ...BREAK_UP_CLOUD_CONTACT_CENTER_COLUMN,
        ],
      },
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
        buttons: ["apply", "reset"],
      },
      groupHeader: "Invoice ARR",
      groupIndex: 5,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrNoCPass = 0 } = params.data;
          return invoiceArrNoCPass;
        }
        const data: Account | null = params.data;

        return currencyFormatter(data?.invoiceArrNoCPass || 0);
      },
      headerTooltip: `<p style="line-height: 16px;font-size: 12px">Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of 'on-premises' and 'cloud' products (SKU) under a given subscription.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                      <div class="ag-cell-label-container" role="presentation">
                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                          <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                          <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                          <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                          <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                          <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                          <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                        </div>
                        <div style="position: absolute;
                        bottom: 6px;
                        left: 25px;
                        color: #00A0D1;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 9px;">(Excludes CPAAS)<div>
                    </div>
                    </div>
                      `,
      },
    },
    {
      headerName: "Invoice ARR (On-Prem)",
      field: "invoiceArrOnPrem",
      colId: "invoiceArrOnPrem",
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: { collection: ONPREM_COLLECTION_COLUMN },
      groupHeader: "Invoice ARR",
      groupIndex: 3,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrOnPrem = 0 } = params.data;
          return invoiceArrOnPrem;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.invoiceArrOnPrem ?? 0);
      },
      headerTooltip: `<p style="line-height:16px;font-size: 12px"> 
Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of 'on-premises' products (SKU) under a given subscription.
${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                    <div class="ag-cell-label-container" role="presentation">
                      <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                      <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                        <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                        <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                      </div>
                      <div style="position: absolute;
                      bottom: 6px;
                      left: 25px;
                      color: #00A0D1;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      font-size: 9px;">(On-Prem)<div>
                  </div>
                  </div>
                    `,
      },
    },
    {
      headerName: "Invoice ARR (Cloud)",
      field: "invoiceArrCloud",
      colId: "invoiceArrCloud",
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [...CLOUD_COLLECTION_COLUMN, ...BREAK_UP_CLOUD_CONTACT_CENTER_COLUMN],
      },
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      groupHeader: "Invoice ARR",
      groupIndex: 4,
      // hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          const { invoiceArrCloud = 0 } = params.data;
          return invoiceArrCloud;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.invoiceArrCloud ?? 0);
      },
      headerTooltip: `<p style="line-height: 16px;font-size:12px">Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of 'cloud' products (SKU) under a given subscription.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                    <div class="ag-cell-label-container" role="presentation">
                      <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                      <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                        <span class="ag-header-cell-text" role="columnheader">Invoice ARR</span>
                        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                        <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                      </div>
                      <div style="position: absolute;
                      bottom: 6px;
                      left: 25px;
                      color: #00A0D1;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      font-size: 9px;">(Cloud)<div>
                  </div>
                  </div>
                    `,
      },
    },
    {
      headerName: "Partner Account Name",
      field: "partnerAccountName",
      colId: "partnerAccountName",
      filter: "PartnerAccountNameFilter",
      filterParams: {
        queryParams: "partnerAccountName",
        axios,
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.partnerAccountName ?? "N/A";
      },
      groupHeader: "Partner",
    },
    {
      headerName: "Partner Group",
      field: "partnerGroup",
      colId: "partnerGroup",
      sortable: true,
      filter: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.partnerGroup ?? "N/A";
      },
      groupHeader: "Partner",
    },
    {
      headerName: "Site URLs",
      field: "sites",
      colId: "sites",
      width: 169,
      minWidth: 100,
      cellRenderer: "SiteURLsRenderer",
      cellRendererParams: {
        type: "download",
        axios,
      },
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "1" },
          { label: "No", value: "0" },
        ],
      },
      sortable: false,
      valueGetter: (params: ValueGetterParams) =>
        params.data?.sites?.length ? joinByKey(params.data.sites, "siteName") : "N/A",
      groupHeader: "Site",
    },
    {
      headerName: "Control Hub Organization ID",
      field: "ciOrgId",
      colId: "ciOrgId",
      width: 292,
      minWidth: 100,
      cellRenderer: "CIOrganizationIDRenderer",
      filter: "agTextColumnFilter",
      filterParams: {
        filterOptions: ["contains"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      sortable: false,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.sites?.length ? joinByKey(params.data.sites, "ciOrgId", true) : "N/A";
      },
      groupHeader: "Customer",
      authKey: "sites",
      headerTooltip: "Common Identity ID associated to the respective Webex Site URLs",
    },
    {
      headerName: "Meetings NPS (last 30 days)",
      field: "meetingNPSScore",
      colId: "meetingNPSScore",
      width: 292,
      minWidth: 100,
      filter: "NumberFilter",
      sortable: true,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.meetingNPSScore !== null && params.data?.meetingNPSScore !== undefined
          ? numberFormat(params.data?.meetingNPSScore, 1)
          : "Not Available";
      },
      exclude: !authDetail.features.includes(FEATURE_KEY.VIEW_MEETINGS_NPS_SCORE),
      headerComponentParams: {
        template: `
              <div class="ag-cell-label-container" role="presentation">
                <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span class="ag-header-cell-text" role="columnheader">Meetings NPS</span>
                  <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                  <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                  <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                  <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                  <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                </div>
                <div style="position: absolute;
                bottom: 6px;
                left: 25px;
                color: #00A0D1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 9px;
                width: -webkit-fill-available;">(last 30 days)<div>
            </div>
            </div>
              `,
      },
      headerTooltip:
        "Net Promoter Score (NPS) of Meetings product for each Webex site under the account. When the score is listed at the account-level, it is the score associated to the primary Webex site under the account.",
    },
    {
      headerName: "Days to renewal",
      field: "daysToRenewal",
      colId: "daysToRenewal",
      filter: "NumberFilter",
      minWidth: 100,
      cellClass: "ag-center",
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.daysToRenewal ?? "N/A";
      },
    },
    {
      headerName: "Renewal Date",
      field: "renewalDate",
      colId: "renewalDate",
      hide: true,
      filter: "DatePickerFilter",
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.renewalDate
          ? moment(params.data.renewalDate).format("MM/DD/YYYY")
          : "N/A";
      },
      headerTooltip: `<p>The date subscription is due for renewal. When an account has multiple subscriptions, the tools only lists the date of earliest renewing subscription.</p>`,
    },
    {
      headerName: "Renewal Term",
      field: "renewalTerm",
      //#TO BE REMOVED# workaround to add this column since backend do not have the column
      colId: "accountSK",
      filter: "agNumberColumnFilter",
      filterParams: {
        filterOptions: ["equals", "lessThan", "greaterThan"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      suppressColumnsToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Fiscal Renewal Quarter",
      field: "renewalQuarter",
      colId: "renewalQuarter",
      filter: "PartnerAccountNameFilter",
      filterParams: {
        queryParams: "fiscalRenewalQuarter",
        axios,
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.renewalQuarter ?? "N/A";
      },
      sortable: true,
    },
    // {
    //   headerName: "Sales Owner Name",
    //   field: "salesOwner",
    //   colId: "salesOwner",
    //   filter: "CheckboxFilter",
    //   filterParams: {
    //     queryParams: "sales-owner",
    //     nullOptionName: "NO SALES OWNER",
    //     axios,
    //   },
    //   hide: true,
    //   valueGetter: (params: ValueGetterParams) =>
    //     params.data?.salesOwner ?? "NO SALES OWNER",
    //   groupHeader: "Sales",
    // },
    {
      headerName: "Country",
      field: "country",
      colId: "country",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "country",
        key: "code",
        axios,
      },
      valueGetter: (params) => {
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.country?.name ?? "N/A";
      },
      cellRenderer: "CountryRenderer",
      groupHeader: "Location",
    },
    {
      headerName: "State/Province",
      field: "state",
      colId: "state",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "state",
        axios,
      },
      groupHeader: "Location",
    },
    {
      headerName: "Account Type",
      field: "channel",
      colId: "channel",
      filter: "CheckboxTreeFilter",
      filterParams: {
        queryParams: "accountType",
        axios,
        authMap: { Online: "portfolio-searchOnlineAccount" },
        authDetail,
      },
      sortable: false,
      cellRenderer: "AccountTypeRenderer",
      groupHeader: "Customer",
    },
    {
      headerName: "Industry Vertical",
      field: "verticalIndustryName",
      colId: "verticalIndustryName",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "vertical-industry-name",
        axios,
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.verticalIndustryName ?? "N/A";
      },
      sortable: false,
    },
    {
      headerName: "Personal Tags",
      field: "personalTags",
      colId: "personalTags",
      hide: true,
      sortable: false,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "personal-tag",
        key: "name",
        axios,
      },
      cellRenderer: "TagsRenderer",
      cellRendererParams: {
        type: "personal-tag",
        axios,
      },
      valueGetter: (params: ValueGetterParams) =>
        params.data?.personalTags?.length ? joinByKey(params.data.personalTags, "name") : "",
      groupHeader: "Tag",
    },
    {
      headerName: "Sub Sales Coverage",
      field: "subSalesCoverage",
      colId: "subSalesCoverage",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "sub-sales-coverage",
        axios,
      },
      sortable: true,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.subSalesCoverage ?? "N/A";
      },
      groupHeader: "Sales",
    },
    {
      headerName: "Contract Theatre",
      field: "contractTheatre",
      colId: "contractTheatre",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "contract-theatre",
        axios,
      },
      sortable: false,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.contractTheatre ?? "N/A";
      },
    },
    {
      headerName: "Sales Level 1",
      field: "salesLevel1",
      colId: "salesLevel1",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "sales-level1",
        axios,
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.salesLevel1 ?? "N/A";
      },
      groupHeader: "Sales",
    },
    {
      headerName: "Sales Level 2",
      field: "salesLevel2",
      colId: "salesLevel2",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "sales-level2",
        axios,
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.salesLevel2 ?? "N/A";
      },
      groupHeader: "Sales",
    },
    {
      headerName: "Sales Level 3",
      field: "salesLevel3",
      colId: "salesLevel3",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "sales-level3",
        axios,
      },
      sortable: false,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.salesLevel3 ?? "N/A";
      },
      groupHeader: "Sales",
    },
    {
      headerName: "Sales Level 4",
      field: "salesLevel4",
      colId: "salesLevel4",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "sales-level4",
        axios,
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.salesLevel4 ?? "N/A";
      },
      groupHeader: "Sales",
    },
    {
      headerName: "Sales Level 5",
      field: "salesLevel5",
      colId: "salesLevel5",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "sales-level5",
        axios,
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.salesLevel5 ?? "N/A";
      },
      groupHeader: "Sales",
    },
    {
      headerName: "Sales Level 6",
      field: "salesLevel6",
      colId: "salesLevel6",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "sales-level6",
        axios,
      },
      sortable: false,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.salesLevel6 ?? "N/A";
      },
      groupHeader: "Sales",
    },
    // {
    //   headerName: "Sales Manager",
    //   field: "salesManagerName",
    //   colId: "salesManagerName",
    //   hide: true,
    //   filter: "CheckboxFilter",
    //   filterParams: {
    //     queryParams: "sales-manager",
    //     axios,
    //   },
    //
    //   valueGetter: (params: ValueGetterParams) =>
    //     params.data?.salesManagerName ?? "N/A",
    //   groupHeader: "Sales",
    // },
    {
      headerName: "Cisco Collab CSM",
      field: "ciscoCsm",
      colId: "ciscoCsm",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "cisco-csm",
        key: "cecId",
        axios,
        nullOptionName: "None",
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        if (params.node.group) {
          return params?.data?.groupName || "None";
        }
        return params.data?.ciscoCsm?.name ?? "None";
      },
      groupHeader: "Cisco Contacts",
      headerTooltip:
        "A Customer Success Manager works to understand a customer’s business needs and align them to Webex services, guides customers to adopt and utilize the full extent of the Webex suite, and continuously reinforces the value of ongoing product evolution.",
    },
    {
      headerName: "Contact Center Onboarding Solutions Manager",
      field: "ccCsmName",
      colId: "ccCsmName",
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/dataservice/v1/metadata/cc-csm?includeInactive=true",
        key: "cecId",
        axios,
        nullOptionName: "None",
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        if (params.node.group) {
          return params?.data?.groupName || "None";
        }
        return params.data?.ccCsmName ?? "None";
      },
      groupHeader: "Cisco Contacts",
    },
    {
      headerName: "Contact Center CSM",
      field: "ccInlifeCsmName",
      colId: "ccInlifeCsmName",
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/dataservice/v1/metadata/cc-csm?includeInactive=true",
        key: "cecId",
        axios,
        nullOptionName: "None",
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        if (params.node.group) {
          return params?.data?.groupName || "None";
        }
        return params.data?.ccInlifeCsmName ?? "None";
      },
      groupHeader: "Cisco Contacts",
    },
    {
      headerName: "Partner CSM",
      field: "partnerCsm",
      colId: "partnerCsm",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "partner-csm",
        key: "cecId",
        axios,
        nullOptionName: "N/A",
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.partnerCsm?.name ?? "N/A";
      },
      groupHeader: "Cisco Contacts",
      headerTooltip:
        " A Customer Success Manager works to understand a customer’s business needs and align them to Webex services, guides customers to adopt and utilize the full extent of the Webex suite, and continuously reinforces the value of ongoing product evolution. In this case, it is the partner who is providing the service and support to the end-customer.",
    },
    {
      headerName: "Leader Of Cisco Collab CSM",
      colId: "ciscoManagerName",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "csm-manager",
        key: "cecId",
        axios,
        nullOptionName: "None",
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.ciscoManagerName ?? "None";
      },

      groupHeader: "Cisco Contacts",
      groupIndex: 1,
    },
    {
      headerName: "Leader Of CSE",
      colId: "ccseManagerName",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "ccse-manager",
        axios,
        nullOptionName: "None",
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.ccseManagerName ?? "None";
      },
      groupHeader: "Cisco Contacts",
      groupIndex: 3,
    },
    {
      headerName: "Leader Of Cisco PSM",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "psm-manager",
        key: "cecId",
        axios,
        nullOptionName: "N/A",
      },
      colId: "partnerManagerName",
      hide: true,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.partnerManagerName ?? "N/A";
      },
      groupHeader: "Cisco Contacts",
      groupIndex: 2,
    },
    {
      headerName: "Organization Name",
      field: "companyName",
      colId: "companyName",
      hide: true,
      sortable: true,
      filter: "agTextColumnFilter",
      cellRenderer: "HighlightFilterModelCellRenderer",
      filterParams: {
        filterOptions: ["contains"],
        suppressAndOrCondition: true,
        resetButton: true,
        applyButton: true,
      },
      headerTooltip:
        "Organization name of the end-customer. An organization can have multiple different accounts and subscriptions. FYI - This field was previously labelled as 'UPO'.",
      valueGetter: (params) => {
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.companyName ?? "N/A";
      },
      groupHeader: "Customer",
    },
    {
      headerName: "Customer Escalation",
      field: "escalationFlag",
      colId: "escalationFlag",
      //editable: true,
      //cellEditor: "EscalationCellEditor",
      //cellRenderer: "EscalationRenderer",
      cellClass: ["ag-react-container-full-height"],
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const isOnlineAccount = params.data?.accountType === "Online";
        return isOnlineAccount ? "N/A" : params.data?.escalationFlag === "Y" ? "Yes" : "No";
      },
      groupHeader: "Customer",
    },
    {
      headerName: "Cluster",
      colId: "sitesPrimaryCluster",
      valueGetter: (params: ValueGetterParams) => {
        const data: Account | undefined = params.data;
        if (data?.sites?.length) {
          const main = data.sites.find((i) => i.primarySite);
          if (main && main.clusterCode) {
            return `${main.clusterCode} - (${main.clusterDataCenter})`;
          }
          return "";
        }
        return "";
      },
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "cluster",
        key: "value",
        axios,
        title: "Cluster",
        headerName: "Cluster",
      },
      sortable: false,
      headerTooltip: `<div>
                            <p>Name of the cluster where the customer's main Webex site URL resides.</p>
                            <p><i style="color:red">Main site:</i>one which has maximum 'Active' hosts in the previous calendar month or is the only site under that account</p>
                      </div>`,
      headerComponentParams: {
        template: `
                                <div class="ag-cell-label-container" role="presentation">
                                  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                                  <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                    <span class="ag-header-cell-text" role="columnheader">Cluster (Main Site)</span>
                                    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                                    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                                    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                                    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                                    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                                  </div>
                              </div>
                                `,
      },
      authKey: "sites",
      groupHeader: "Site",
    },
    {
      headerName: "Desktop App Version",
      colId: "sitesPrimaryWebexVersion",
      field: "desktopAppVersion",
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/dataservice/v1/metadata/desktop-app-version",
        axios,
        title: "Desktop App Version",
      },
      valueGetter: (params: ValueGetterParams) => {
        const data: Account | undefined = params.data;
        if (data?.sites?.length) {
          const main = data.sites.find((i) => i.primarySite);
          if (main) {
            return main.desktopAppVersion;
          }
          return "";
        }
        return "";
      },
      hide: true,
      sortable: false,
      headerTooltip: `<div>
      <p>Version associated to the customer's main Webex site URL.</p>
      <p><i style="color:red">Main site:</i>one which has maximum 'Active' hosts in the previous calendar month or is the only site under that account</p>
  </div>`,
      headerComponentParams: {
        template: `
                            <div class="ag-cell-label-container" role="presentation">
                              <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                              <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                <span class="ag-header-cell-text" role="columnheader">Desktop App Version (Main Site)</span>
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                              </div>
                          </div>
                            `,
      },
      authKey: "sites",
      groupHeader: "Site",
    },
    {
      headerName: "Cisco Collab Success Plan",
      field: "expandPlanCreatedDate",
      colId: "expandPlanCreatedDate",
      width: 169,
      minWidth: 180,
      hide: true,
      valueGetter: (params: ValueGetterParams) =>
        params.data?.expandPlanCreatedDate
          ? "Yes (" +
            moment(params.data.expandPlanCreatedDate)
              .tz("America/Los_Angeles")
              .format("MM/DD/YYYY") +
            ")"
          : "No",
      cellRenderer: "ExpandPlanRenderer",
      filter: "ExpandPlanFilter",
      cellRendererParams: {
        axios,
        type: ExpandPlanTypeEnum.Cisco,
        authDetail,
      },
      groupHeader: "Resource",
    },
    {
      headerName: "Business Reviews",
      field: "qvrFiscalQuarter",
      colId: "qvrFiscalQuarter",
      cellRenderer: "QVRRenderer",
      exclude: !authDetail.features.includes(FEATURE_KEY.VIEW_QVR),
      headerTooltip: "Log 'Business Reviews' you already had or plan to have with the customer.",
      cellRendererParams: {
        axios,
        type: ExpandPlanTypeEnum.Cisco,
        authDetail,
      },
      valueGetter: (params: ValueGetterParams) =>
        params.data?.qvrFiscalQuarter ? "Yes (" + params.data.qvrFiscalQuarter + ")" : "No",
      filter: "QuaterViewReviewFilter",
      filterParams: {
        queryParams: "qvr-filter",
        axios,
        nullOptionName: "No",
      },
      sortable: true,
    },
    {
      headerName: "Partner Collab Success Plan (latest update)",
      field: "partnerExpandPlanCreatedDate",
      colId: "partnerExpandPlanCreatedDate",
      width: 169,
      minWidth: 180,
      hide: true,
      valueGetter: (params: ValueGetterParams) =>
        params.data?.partnerExpandPlanCreatedDate
          ? "Yes (" +
            moment(params.data.partnerExpandPlanCreatedDate)
              .tz("America/Los_Angeles")
              .format("MM/DD/YYYY") +
            ")"
          : "No",
      cellRenderer: "ExpandPlanRenderer",
      filter: "ExpandPlanFilter",
      cellRendererParams: {
        axios,
        type: ExpandPlanTypeEnum.Partner,
        authDetail,
      },
      groupHeader: "Resource",
    },
    {
      headerName: "Competitors",
      field: "competitorDiscoveries",
      colId: "competitorDiscoveries",
      width: 140,
      minWidth: 100,
      filter: "CheckboxFilter",
      cellRenderer: "CompetitorRenderer",
      filterParams: {
        queryParams: "competitors",
        axios,
      },
      sortable: false,
      valueGetter: (params: ValueGetterParams) =>
        params.data?.competitorDiscoveries
          ? Object.keys(params.data?.competitorDiscoveries).join(" | ")
          : "",
    },
    {
      headerName: "PSM Name",
      field: "psm",
      colId: "psm",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "psm",
        key: "cecId",
        axios,
        nullOptionName: "N/A",
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.psm?.name ?? "N/A";
      },
      headerTooltip:
        " A Partner Success Manager works to understand a Life-Cycle Managed Partner's business needs and align them to Webex services, guides customers to adopt and utilize the full extent of the Webex suite, and continuously reinforces the value of ongoing product evolution.",
      groupHeader: "Cisco Contacts",
    },
    {
      headerName: "Shared Tags",
      field: "managementTags",
      colId: "managementTags",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "management-tag",
        key: "name",
        axios,
      },
      sortable: false,
      cellRenderer: "TagsRenderer",
      cellRendererParams: {
        type: "management-tag",
        axios,
        authDetail,
      },
      valueGetter: (params: ValueGetterParams) => {
        return params.data?.managementTags?.length
          ? joinByKey(params.data.managementTags, "name")
          : "";
      },
      groupHeader: "Tag",
    },
    {
      headerName: "DSM",
      field: "dsmName",
      colId: "dsmName",
      hide: true,
      editable: false,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "cx-dsm?includeInactive=1",
        axios,
        nullOptionName: "None",
        key: "cecId",
        nameKey: "name",
      },
      headerTooltip:
        "DSM is a technical resource that focuses on both proactive activities such as onboarding, adoption, best practices, product feature reviews, technical reviews, etc., and reactive activities such as incident and escalation management and TAC case reviews (SWSS Premium only). A DSM supports Collaboration (Webex), Security and On-Premise technology and is aligned for the lifecycle of the contract.",
      sortable: true,
      // valueParser: valueParser,
      cellRenderer: "EditableCellRenderer",
      valueGetter: (params) => {
        if (params.node.group) {
          return params?.data?.groupName;
        }
        return params.data?.dsmName ?? "None";
      },
      groupHeader: "Cisco Contacts",
    },
    {
      headerName: "CSE",
      field: "ccseName",
      colId: "ccseName",
      hide: true,
      editable: (param) =>
        param?.data.accountStatus === "Active" &&
        param?.data.accountType !== "Online" &&
        authDetail.features.includes(FEATURE_KEY.PORTFOLIO_EDIT_TAE) &&
        !embedded,
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/portfolio/metadata/ccse?includeInactive=true",
        axios,
        key: "ccseName",
        nameKey: "ccseName",
        nullOptionName: "None",
      },
      headerTooltip:
        "Collaboration Customer Success Engineer (CSE) driving Technical Adoption & removing technical roadblocks to Cisco collaboration customers.",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName;
        }
        return params.data?.ccseName ?? "None";
      },
      valueSetter: (params) => {
        const { newValue, oldValue, node, data } = params;
        if (newValue === oldValue) {
          return false;
        } else {
          const valueArray: string[] = newValue?.split(", ") ?? [];
          const ccseList = ccse.filter((x) => valueArray.includes(x.ccseName));
          if (newValue === "None") {
          } else if (ccseList.length !== valueArray.length) {
            toast.error("Invalid CSE", {
              position: "top-center",
              autoClose: 2000,
            });
            return false;
          }

          node.setData({ ...data, ccseName: newValue });
          axios
            .put(`/api/dataservice/v1/accounts/${data?.accountId}/operation-contact`, { ccseList })
            .then(({ data: resData }) => {
              node.setData({
                ...data,
                ccseManagerName: resData.ccseManagerName ? resData.ccseManagerName : null,
                ccseName: resData.ccseName ? resData.ccseName : null,
              });
            })
            .catch((e) => {
              toast.error(e?.response?.data?.message || "Fail to update", {
                position: "top-center",
                autoClose: 2000,
              });
            });
          return true;
        }
      },
      cellRenderer: "EditableCellRenderer",
      cellEditor: "CCSECellEditor",
      groupHeader: "Cisco Contacts",
    },
    {
      headerName: "Auto Renew Off/Pending Cancel",
      field: "arOffPCCount",
      colId: "arOffPCCount",
      hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "1" },
          { label: "No", value: "0" },
        ],
      },
      headerClass: [styles.aroffPCHeader],
      cellClass: (params) => [
        params.node.rowPinned
          ? params.data.status
            ? `${styles.arroffPCCellInTotal}`
            : ""
          : `${styles.arroffPCCell}`,
      ],
      // toolPanelClass: ["column_alert"],
      pinned: "left",
      headerTooltip:
        "Identify accounts (CCW/CCE) that have at least one subscription with a 'Pending Cancel' (PC) order and/or has Auto Renew (AR) turned off. It also covers those newly created subscriptions with Zero Renewal term.",
      valueGetter: (params: ValueGetterParams) => {
        if (!params.node.rowPinned) {
          return params.data?.arOffPCCount > 0
            ? `Yes (${params.data?.arOffPCCount}/${params.data?.subscriptionCount})`
            : `No (${params.data?.arOffPCCount}/${params.data?.subscriptionCount})`;
        }
      },
      cellRenderer: "AROffPendingCancelRenderer",
      cellRendererParams: {
        axios,
        authDetail,
      },
      minWidth: 200,
    },
    {
      headerName: "OneView Health Score",
      colId: "healthScore",
      field: "healthScore",
      sortable: true,
      cellRenderer: "HealthScoreRenderer",
      filter: "PercentFilter",
      headerTooltip: healthTip,
      headerComponentParams: {
        template: `
            <div class="ag-cell-label-container" role="presentation">
              <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
              <div ref="eLabel" class="ag-header-cell-label" role="presentation" style="padding-left:8px;">
                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
              </div>
              <div class="tooltip_container">
                <i class="cui-icon icon icon-info_16"></i>
              </div>
          </div>
            `,
      },
      groupHeader: "Health",
    },
    {
      headerName: "Health Rank",
      colId: "alertGroup",
      field: "alertGroup",
      sortable: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "tier",
        key: "value",
        axios,
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return (
            RANK_VALUE_LIST?.find((i) => params.data?.groupName === i.id)?.risk || "No Health Rank"
          );
        }
        return params.data?.alertGroup
          ? RANK_VALUE_LIST?.find((i) => params.data?.alertGroup === i.id)?.risk
          : "No Health Rank";
      },
      cellClass: (params) =>
        RANK_VALUE_LIST?.find((i) => params?.data?.alertGroup === i.id)?.color ?? "",
      headerTooltip: `<p>Only the accounts with ‘Active’ subscription having at least one license and a Webex site are systematically assigned to a health rank to quickly visualize their propensity to churn. There are over 100 data points considered in this segmentation. There are 4 main areas of focus:</p><ul><li>Account Spend (i.e. MRR / Price per AH / # of purchased licenses)</li><li>Account Profile (i.e. Audio Type / Geo Area / Deployment Model / LCM managed)</li><li>Account Configuration (i.e. SSO enabled / Directory Sync / Hybrid Calling)</li><li>Account Adoption (i.e. Daily number of AH / Daily Number of Meetings / Product NPS score)</li></ul><p>For reference, the general distribution of accounts is:</p><p>No Risk - 8% | Minimal Risk - 70% | Moderate Risk - 15% | Significant Risk - 9%</p>`,
      headerComponentParams: {
        template: `
            <div class="ag-cell-label-container" role="presentation">
              <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
              <div ref="eLabel" class="ag-header-cell-label" role="presentation" style="padding-left:8px;">
                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
              </div>
              <div class="tooltip_container">
                <i class="cui-icon icon icon-info_16"></i>
              </div>
          </div>
            `,
      },
      groupHeader: "Health",
    },
    {
      headerName: "Health Rank Conflicts",
      colId: "conflictColor",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "conflict",
        key: "value",
        axios,
      },
      lockVisible: true,
      authKey: "alertGroup",
      toolPanelClass: ["skip_visiable_check"],
      groupHeader: "Health",
    },
    {
      headerName: "Service Start Date",
      field: "closestSubscriptionServiceStartDate",
      colId: "closestSubscriptionServiceStartDate",
      filter: "DatePickerFilter",
      filterParams: {
        orInNextDisplay: false,
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.closestSubscriptionServiceStartDate
          ? moment(params.data.closestSubscriptionServiceStartDate).format("MM/DD/YYYY")
          : "N/A";
      },
      headerTooltip: `<p>The subscription effective from date. When an account has multiple subscriptions, the tools only lists the date of earliest renewing subscription.</p>`,
    },
    {
      headerName: `Customer Health Assessment (sourced from Cisco Collab Success Plan)`,
      colId: "expandPlanRiskAssessment",
      field: "expandPlanRiskAssessment",
      sortable: true,
      hide: true,
      headerComponentParams: {
        template: `
            <div class="ag-cell-label-container" role="presentation">
              <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
              <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span class="ag-header-cell-text" role="columnheader">Customer Health Assessment</span>
                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
              </div>
              <div style="
              position: absolute;
              bottom: 5px;
              left: 25px;
              color: #00A0D1;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 9px;
              width: -webkit-fill-available;">(sourced from Cisco Collab Success Plan)<div>
          </div>
            `,
      },
      headerTooltip: `
      <div>
       <div>Customer Health Assessment (ORA) value sourced from the latest "Cisco Collab Success Plan" that is either in 'Completed' or 'In-Progress' status. And when there is no plan created, then the value will follow below logic:</div>
       <div>1: When Cisco Collab CSM = a named CSM, team alias, or Global Customer Care, AND Suite ARR >$500K OR Non-Suite Cloud Meetings/Messaging + Non-Suite Cloud Calling ARR >$500K; then display 'Not Set'</div>
       <div>2: When Cisco Collab CSM = a named CSM, team alias, or Global Customer Care, AND Suite ARR <$500K AND Non-Suite Cloud Meetings/Messaging + Non-Suite Cloud Calling ARR <$500K; then display 'N/A'</div>
       <div>3: When Cisco Collab CSM = Partner Success Supported, display 'Partner Success Supported' instead of 'Not Set'</div>
       <div>4: When Cisco Collab CSM = BU Contact Center Supported, display 'BU Contact Center Supported' instead of 'Not Set'</div>
       <div>5: When Cisco Collab CSM = BU CPAAS Supported, display 'BU CPAAS Supported' instead of 'Not Set'</div>
      </div>
      `,
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "Not Set";
        }
        return params.data?.expandPlanRiskAssessment ?? "Not Set";
      },
      cellClass: (params) => params?.data?.expandPlanRiskAssessment?.replace(" ", "") ?? "",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "overallRiskPortfolio",
        key: "value",
        axios,
      },
      groupHeader: "Health",
    },
    {
      headerName: `Customer Health Assessment (sourced from Partner Collab Success Plan)`,
      colId: "partnerExpandPlanRiskAssessment",
      field: "partnerExpandPlanRiskAssessment",
      sortable: true,
      hide: true,
      headerComponentParams: {
        template: `
            <div class="ag-cell-label-container" role="presentation">
              <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
              <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span class="ag-header-cell-text" role="columnheader">Customer Health Assessment</span>
                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
              </div>
              <div style="
              position: absolute;
              bottom: 5px;
              left: 25px;
              color: #00A0D1;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 9px;
              width: -webkit-fill-available;">(sourced from Partner Collab Success Plan)<div>
          </div>
            `,
      },
      headerTooltip: `Customer Health Assessment (ORA) value sourced from the latest "Partner Collab Success Plan" that is either in 'Completed' or 'In-Progress' status. And when there is no plan created, then the value is 'Not Set'.`,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.partnerExpandPlanRiskAssessment ?? "Not Set";
      },
      cellClass: (params) => params?.data?.partnerExpandPlanRiskAssessment?.replace(" ", "") ?? "",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "overallRiskPortfolio",
        key: "value",
        axios,
      },
      groupHeader: "Health",
    },
    // {
    //   headerName: `Collab Map`,
    //   colId: "collabMapUploadedDate",
    //   field: "collabMapUploadedDate",
    //   sortable: true,
    //   hide: true,
    //   valueGetter: (params: ValueGetterParams) =>
    //     params?.data?.collabMapUploadedDate
    //       ? "Yes (" +
    //         moment(params?.data?.collabMapUploadedDate).format("MM/DD/YYYY") +
    //         ")"
    //       : "No",
    //   cellRenderer: "CollabMapRenderer",
    //   filter: "CollabMapFilter",
    //   cellRendererParams: {
    //     axios,
    //     authDetail,
    //   },
    //   groupHeader: "Resource",
    // },
    {
      headerName: `Concierge`,
      colId: "conciergeStatus",
      field: "conciergeStatus",
      sortable: true,
      hide: true,
      valueGetter: (params: ValueGetterParams) =>
        params.data?.conciergeStatus === "Active"
          ? "Active (" + moment(params?.data?.conciergeEffectiveTo).format("MM/DD/YYYY") + ")"
          : params.data?.conciergeStatus === "Not Started"
            ? "Not Started (" +
              moment(params?.data?.conciergeEffectiveFrom).format("MM/DD/YYYY") +
              ")"
            : (params?.data?.conciergeStatus ?? "No"),
      filter: "ConciergeFilter",
      cellRenderer: "ConciergeRenderer",
      cellRendererParams: {
        axios,
        authDetail,
      },

      headerTooltip: `Webex Concierge Service provides a customer with a dedicated CSE resource. While not replacing standard Webex Support and TAC, they act as the customers point of contact as their technical expert for all things Webex through optimizing the experience, knowledge transfers, training, escalation management, proactive & predictive support, and change management.`,
    },
    {
      headerName: "Account Engagement Model",
      field: "coverageStatus",
      colId: "coverageStatus",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "coverage-status-nonfed",
        axios,
        nameKey: "name",
        key: "value",
      },
      sortable: true,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.coverageStatus ?? "";
      },
      cellRenderer: "CoverageStatusRenderer",
      cellRendererParams: {
        type: "account",
      },
      cellClass: ["ag-react-container-full-height"],
      headerTooltip: TOOLTIP["Account Engagement Model"],
      groupHeader: "Engagement Model",
    },
    {
      headerName: "AEM Exception Reason",
      field: "aemExpReason",
      colId: "aemExpReason",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.aemExpReason ?? "";
        return data;
      },
      cellRenderer: "ReasonRenderer",
      cellRendererParams: {
        type: "account",
      },
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "not null" },
          { label: "No", value: "null" },
        ],
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "AEM Exception Date",
      field: "aemExpDate",
      colId: "aemExpDate",
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      filter: "DatePickerFilter",
      filterParams: {
        orInNextDisplay: false,
      },
      groupHeader: "Engagement Model",
    },
    // {
    //   headerName: "Anchor Product(s)",
    //   field: "anchorProducts",
    //   colId: "anchorProducts",
    //   hide: true,
    //   filter: "CheckboxFilter",
    //   filterParams: {
    //     customPath:
    //       "/api/dataservice/v1/metadata/lookups?category=ANCHOR_PRODUCT",
    //     axios,
    //     nameKey: "value",
    //     key: "value",
    //     nullOptionName: "(Blank)",
    //   },
    //   sortable: false,
    //   valueGetter: (params: ValueGetterParams) => {
    //     if (params.node.rowPinned) return "";
    //     return params.data?.anchorProducts?.length
    //       ? params.data?.anchorProducts
    //           .map((x: string) => {
    //             const [type, value] = x?.split("%-%");
    //             return value ? `Other - ${value}` : type;
    //           })
    //           .join(", ")
    //       : "";
    //   },
    //   cellRenderer: "AnchorProductRenderer",
    //   cellRendererParams: {
    //     minWidth: 260,
    //   },
    //   cellClass: ["ag-react-container-full-height"],
    //   headerTooltip:
    //     "<p>Primary product(s) for which customer purchased Webex. The value can only be updated by the Collab Customer Success team.</p>",
    // },
    {
      headerName: "Suite Anchor",
      field: "suiteAnchor",
      colId: "suiteAnchor",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/dataservice/v1/metadata/lookups?category=SUITE_ANCHOR",
        axios,
        nameKey: "value",
        key: "code",
        nullOptionName: "N/A",
      },
      sortable: false,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.suiteAnchor?.length ? params.data?.suiteAnchor.join(", ") : "N/A";
      },
      cellClass: ["ag-react-container-full-height"],
    },
    {
      headerName: "Calling ePSM",
      field: "callingEpsmName",
      colId: "callingEpsmName",
      hide: true,
      editable: (param) =>
        param?.data.accountStatus === "Active" &&
        param?.data.accountType !== "Online" &&
        authDetail.features.includes(FEATURE_KEY.PORTFOLIO_EDIT_CALLING_PSM) &&
        !embedded,
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/portfolio/metadata/calling-epsm?includeInactive=true",
        axios,
        key: "cecId",
        nameKey: "name",
        nullOptionName: "None",
      },
      headerTooltip:
        "Cisco's named Enterprise Partner Success Manager (ePSM) providing Cloud Calling support to the end-customer",

      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName;
        }
        return params.data?.callingEpsmName ?? "None";
      },
      valueSetter: (params: any) => {
        const { newValue, oldValue, node, data } = params;
        if (newValue === oldValue) {
          return false;
        } else {
          const valueArray: string[] = newValue?.split(", ") ?? [];
          const epsmList = callingEpsm?.filter((x) => valueArray.includes(x.name));
          if (epsmList.length !== valueArray.length) {
            toast.error("Invalid Calling ePSM", {
              position: "top-center",
              autoClose: 2000,
            });
            return false;
          }
          node.setData({
            ...data,
            callingEpsmManagerName: epsmList
              .map((i) => {
                return i.managerName;
              })
              .join(","),
            callingEpsmName: newValue,
          });

          axios
            .put(`/api/dataservice/v1/accounts/${data?.accountId}/operation-callings`, {
              callingEpsms: epsmList,
            })
            .then((res) => {
              if (res?.status === 200) {
                // if epsmList === [] && callingPsmName === null
                // then myaccounts - 1
                if (!epsmList.length && !data.callingPsmName) {
                  dispatchCustomEvent<{ type: "REMOVE" }>("CALLING_ASSIGN_CHANGE", {
                    type: "REMOVE",
                  });
                }
              } else {
                toast.error("Fail to update", {
                  position: "top-center",
                  autoClose: 2000,
                });
              }
            });
          return true;
        }
      },
      cellRenderer: "EditableCellRenderer",
      cellEditor: "CallingEpsmCellEditor",
      cellEditorParams: {
        type: "epsm",
      },
      groupHeader: "Cisco Contacts",
    },
    {
      headerName: "Calling PSM",
      field: "callingPsmName",
      colId: "callingPsmName",
      hide: true,
      editable: (param) =>
        param?.data.accountStatus === "Active" &&
        param?.data.accountType !== "Online" &&
        authDetail.features.includes(FEATURE_KEY.PORTFOLIO_EDIT_CALLING_PSM) &&
        !embedded,
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/portfolio/metadata/calling-psm?includeInactive=true",
        axios,
        key: "cecId",
        nullOptionName: "None",
      },
      headerTooltip:
        "Cisco's named Partner Success Manager (PSM) providing Cloud Calling support to the Partner",

      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName;
        }
        return params.data?.callingPsmName ?? "None";
      },
      valueSetter: (params: any) => {
        const { newValue, oldValue, node, data } = params;
        if (newValue === oldValue) {
          return false;
        } else {
          const valueArray: string[] = newValue?.split(", ") ?? [];
          const psmList = callingPsm?.filter((x) => valueArray.includes(x.name));
          if (psmList.length !== valueArray.length) {
            toast.error("Invalid Calling PSM", {
              position: "top-center",
              autoClose: 2000,
            });
            return false;
          }
          node.setData({
            ...data,
            callingPsmManagerName: psmList
              .map((i) => {
                return i.managerName;
              })
              .join(","),
            callingPsmName: newValue,
          });
          axios
            .put(`/api/dataservice/v1/accounts/${data?.accountId}/operation-callings`, {
              callingPsms: psmList,
            })
            .then((res) => {
              if (res?.status === 200) {
                // if psmList === [] && callingEpsmName === null
                // then myaccounts - 1
                if (!psmList.length && !data.callingEpsmName) {
                  dispatchCustomEvent<{ type: "REMOVE" }>("CALLING_ASSIGN_CHANGE", {
                    type: "REMOVE",
                  });
                }
              } else {
                toast.error("Fail to update", {
                  position: "top-center",
                  autoClose: 2000,
                });
              }
            });
          return true;
        }
      },
      cellRenderer: "EditableCellRenderer",
      cellEditor: "CallingEpsmCellEditor",
      cellEditorParams: {
        type: "psm",
      },
      groupHeader: "Cisco Contacts",
    },
    {
      headerName: "Leader of Calling ePSM",
      colId: "callingEpsmManagerName",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/portfolio/metadata/calling-epsm-manager?includeInactive=true",
        axios,
        key: "cecId",
        nullOptionName: "None",
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.callingEpsmManagerName ?? "None";
      },
      groupHeader: "Cisco Contacts",
      groupIndex: 3,
      headerTooltip:
        "Manager of Cisco's named Enterprise Partner Success Manager (ePSM) providing Cloud Calling support to the end-customer",
    },
    {
      headerName: "Leader of Calling PSM",
      colId: "callingPsmManagerName",
      hide: true,
      filter: "CheckboxFilter",
      filterParams: {
        customPath: "/api/portfolio/metadata/calling-psm-manager?includeInactive=true",
        axios,
        key: "cecId",
        nullOptionName: "None",
      },
      valueGetter: (params: ValueGetterParams) => {
        if (params.node.rowPinned) return "";
        return params.data?.callingPsmManagerName ?? "None";
      },
      groupHeader: "Cisco Contacts",
      groupIndex: 3,
      headerTooltip:
        "Manager of Cisco's named Partner Success Manager (PSM) providing Cloud Calling support to the Partner",
    },
    {
      headerName: "Invoice ARR (Other - Security)",
      field: "invoiceArrNonCollabSecurity",
      colId: "invoiceArrNonCollabSecurity",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        return currencyFormatter(params.data?.invoiceArrNonCollabSecurity);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (Other - Technical Support / Service)",
      field: "invoiceArrNonCollabService",
      colId: "invoiceArrNonCollabService",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        return currencyFormatter(params.data?.invoiceArrNonCollabService);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (Other - Undefined)",
      field: "invoiceArrNonCollabOther",
      colId: "invoiceArrNonCollabOther",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        return currencyFormatter(params.data?.invoiceArrNonCollabOther);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Invoice ARR (Cloud - CPAAS GPL)",
      field: "invoiceArrCPassCloud",
      colId: "invoiceArrCPassCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,
      valueGetter: (params) => {
        return currencyFormatter(params.data?.invoiceArrCPassCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Organization Invoice ARR (Collab + Non-Collab)",
      field: "invoiceArrOrgTotal",
      colId: "invoiceArrOrgTotal",
      filter: "NumberFilter",
      filterParams: {
        showBlank: false,
      },
      groupHeader: "Invoice ARR",
      groupIndex: 7,
      hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "OrganizationInvoiceArrCellRenderer",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "-";
        }
        const data: Account | null = params.data;
        if (data?.invoiceArrOrgTotal !== null) {
          return currencyFormatter(data?.invoiceArrOrgTotal);
        }
      },
      headerTooltip: `<ul><li style="line-height: 1.2">It shows the sum of Invoice ARR (Collab + non-Collab) for all the accounts under the same organization.</li>
<li style="line-height: 1.2">Case when the Organization has both ‘Active’ and ‘Inactive’ accounts, then the system will only consider and calculate the ARR for all the ‘Active’ accounts under that organization.</li>
<li style="line-height: 1.2">Case when all accounts under the Organization are 'Inactive', then the system will consider and calculate the ARR of last 'Active' subscriptions for each account under the organization.</li></ul>`,
      headerComponentParams: {
        template: `
                  <div class="ag-cell-label-container" role="presentation">
                    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                      <span class="ag-header-cell-text" role="columnheader">Organization Invoice ARR</span>
                      <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                      <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                      <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                      <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                      <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                    </div>
                    <div style="position: absolute;
                    bottom: 6px;
                    left: 25px;
                    color: #00A0D1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 9px;">(Collab + Non-Collab)<div>
                </div>
                </div>
                  `,
      },
    },
    {
      headerName: "CH Foundational Config Status",
      field: "ciOrgFoundationalStatus",
      colId: "ciOrgFoundationalStatus",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Met", value: "Met" },
          { label: "Not Met", value: "Not Met" },
          { label: "N/A", value: "null" },
        ],
      },
      sortable: true,
      cellRenderer: "ChConfigStatusRenderer",
      cellRendererParams: {
        statusField: "foundationalStatus",
      },
      headerComponent: "CustomTooltipHeader",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return data ? data.ciOrgFoundationalStatus : "N/A";
      },
      headerComponentParams: {
        headerTooltip: `<div>
        <p style="font-size: 14px;font-weight: 600">Domain Verification:</p>
        <p style="font-size: 12px;">Verifying domains is a way of “proving” to Cisco that you own the email domains you tell us you do. This step ensures that you can move all users with those email domains into your primary org as part of this process. If you want users to have a cohesive collab experience with the security protocols you’ve aligned from the top-down, domain verification has to happen. If domains and users aren’t verified/claimed, you’ll lose out on accurate analytics and a lesser ability to effectively use the troubleshooting tools.<span>Help Article = <a href="https://help.webex.com/en-us/article/cd6d84/Manage-your-domains" target="_blank">https://help.webex.com/en-us/article/cd6d84/Manage-your-domains</a></span></p>
        <br/>
        <p style="font-size: 14px;font-weight: 600">User Claim:</p>
        <p style="font-size: 12px;">Claiming users is just as it sounds. Over time, if you haven't set up your Webex identity technical readiness (followed this process), your users could have created free trial accounts. Entire departments could have set up accounts separately from your primary org. Once your domains have been verified, we have a process to go out and find all users outside your primary org with those domains in their email addresses so you can round them up and bring them into your org. This will give them the experience you’ve designed, access to enterprise features and subscriptions they might not otherwise have, and could even lower the cost of collaboration overall for you (by eliminating duplicate agreements, etc.).<span>Help Article = <a href="https://help.webex.com/en-us/article/nceb8tm/Claim-users-to-your-organization-(%22convert%22-users)" target="_blank">https://help.webex.com/en-us/article/nceb8tm/Claim-users-to-your-organization-(%22convert%22-users)</a></span></p>
        <br/>
        <p style="font-size: 14px;font-weight: 600">Auto License Template:</p>
        <p style="font-size: 12px;">Streamline the onboarding experience for you and your users. When new users are added to your organization, they will automatically be given the license privileges you determine.<span>Help Article = <a href="https://help.webex.com/en-us/article/n3ijtao/Set-up-automatic-license-assignments-in-Control-Hub" blank="_blank"> https://help.webex.com/en-us/article/n3ijtao/Set-up-automatic-license-assignments-in-Control-Hub</a></span></p>
        <br/>
        <p style="font-size: 14px;font-weight: 600">Domain Claim:</p>
        <p style="font-size: 12px;">So now you’ve verified the domains that are yours. You’ve claimed free-floating users. It’s time to claim the domains to prevent anyone else from getting into the scenario you just cleaned up. This sets you up for a much better expansion strategy, allows you to continue delivering a common experience to all your users, and perhaps most critically important, makes sure that anyone new has the security requirements in place that you have aligned/approved.<span>Help Article = <a href="https://help.webex.com/en-us/article/cd6d84/Manage-your-domains" target="_blank">https://help.webex.com/en-us/article/cd6d84/Manage-your-domains</a></span></p>
        </div>`,
      },
    },
    {
      headerName: "CH Advanced Config Status",
      field: "ciOrgAdvanceStatus",
      colId: "ciOrgAdvanceStatus",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Met", value: "Met" },
          { label: "Not Met", value: "Not Met" },
          { label: "N/A", value: "null" },
        ],
      },
      sortable: true,
      cellRenderer: "ChConfigStatusRenderer",
      cellRendererParams: {
        statusField: "advanceStatus",
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return data ? data.ciOrgAdvanceStatus : "N/A";
      },
      // headerTooltip: `wait……`,
    },
    {
      headerName: "Products & Services",
      field: "productServices",
      colId: "productServices",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return data?.productServices?.length ? data?.productServices : "N/A";
      },
      cellRenderer: "ProductRenderer",
      cellRendererParams: {
        enableGroup: false,
      },
      filter: "ProductServiceFilter",
      filterParams: {
        queryParams: "product-service",
        axios,
      },
    },
    {
      headerName: "OneX (CX) CSE",
      field: "cxCseName",
      colId: "cxCseName",
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "cx-cse",
        key: "cecId",
        axios,
        nullOptionName: "N/A",
      },
      valueGetter: (params) => {
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        return params.data?.cxCseName ?? "N/A";
      },
      groupHeader: "Cisco Contacts",
    },
    {
      colId: "mtgRenewedSub",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Cloud Meeting Renewed Subscription",
    },
    {
      colId: "mtgPendingSub",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Cloud Meeting Pending Subscription",
    },
    {
      colId: "calRenewedSub",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Cloud Calling Renewed Subscription",
    },
    {
      colId: "callPendingSub",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      hide: true,
      lockVisible: true,
      toolPanelClass: ["skip_visiable_check"],
      headerName: "Cloud Calling Pending Subscription",
    },
    {
      colId: "sitesPrimaryWSMPFlag",
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "Y" },
          { label: "No", value: "N" },
        ],
      },
      sortable: false,
      headerName: "WSMP Meetings Flag",
      headerComponentParams: {
        template: `
                            <div class="ag-cell-label-container" role="presentation">
                              <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                              <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                <span class="ag-header-cell-text" role="columnheader">WSMP Meetings Flag (Main Site)</span>
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                              </div>
                          </div>
                            `,
      },
      authKey: "sites",
      groupHeader: "Site",
      valueGetter: (params: ValueGetterParams) => {
        const data: Account | undefined = params.data;
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        if (data?.sites?.length) {
          const main = data.sites.find((i) => i.primarySite);
          if (main && main.wsmpFlag) {
            return main.wsmpFlag ? (main.wsmpFlag === "N" ? "No" : "Yes") : "N/A";
          }
          return "N/A";
        }
        return "N/A";
      },
    },
    {
      colId: "sitesPrimaryWSMPDate",
      filter: false,
      sortable: false,
      headerName: "WSMP Meetings Migration Date",
      headerComponentParams: {
        template: `
                            <div class="ag-cell-label-container" role="presentation">
                              <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                              <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                <span class="ag-header-cell-text" role="columnheader">WSMP Meetings Migration Date (Main Site)</span>
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                              </div>
                          </div>
                            `,
      },
      authKey: "sites",
      groupHeader: "Site",
      valueGetter: (params: ValueGetterParams) => {
        const data: Account | undefined = params.data;
        if (params.node.rowPinned) return "";
        if (params.node.group) {
          return params?.data?.groupName || "N/A";
        }
        if (data?.sites?.length) {
          const main = data.sites.find((i) => i.primarySite);
          if (main && main.wsmpDate) {
            return main.wsmpDate ? moment(main.wsmpDate).format("MM/DD/YYYY") : "N/A";
          }
          return "N/A";
        }
        return "N/A";
      },
    },
    // {
    //   headerName: "Total Video Device Bookings $$ (Last 6 Months)",
    //   field: "videoDeviceAmount6M",
    //   colId: "videoDeviceAmount6M",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     return currencyFormatter(data?.videoDeviceAmount6M ?? 0) ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings $$",
    //   headerTooltip: "Total Video Device Bookings $$ (Last 6 Months)",
    // },
    // {
    //   headerName: "Total Video Device Bookings QTY (Last 6 Months)",
    //   field: "videoDeviceQty6M",
    //   colId: "videoDeviceQty6M",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     return data?.videoDeviceQty6M?.toLocaleString() ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings QTY",
    //   headerTooltip: "Total Video Device Bookings QTY (Last 6 Months)",
    // },
    // {
    //   headerName: "Total Video Device Bookings $$ (Last 12 Months)",
    //   field: "videoDeviceAmount12M",
    //   colId: "videoDeviceAmount12M",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     return currencyFormatter(data?.videoDeviceAmount12M ?? 0) ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings $$",
    //   headerTooltip: "Total Video Device Bookings $$ (Last 12 Months)",
    // },
    // {
    //   headerName: "Total Video Device Bookings QTY (Last 12 Months)",
    //   field: "videoDeviceQty12M",
    //   colId: "videoDeviceQty12M",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     return data?.videoDeviceQty12M?.toLocaleString() ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings QTY",
    //   headerTooltip: "Total Video Device Bookings QTY (Last 12 Months)",
    // },
    // {
    //   headerName: "Total Video Device Bookings $$ (Last 24 Months)",
    //   field: "videoDeviceAmount24M",
    //   colId: "videoDeviceAmount24M",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     return currencyFormatter(data?.videoDeviceAmount24M ?? 0) ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings $$",
    //   headerTooltip: "Total Video Device Bookings $$ (Last 24 Months)",
    // },
    // {
    //   headerName: "Total Video Device Bookings QTY (Last 24 Months)",
    //   field: "videoDeviceQty24M",
    //   colId: "videoDeviceQty24M",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     return data?.videoDeviceQty24M?.toLocaleString() ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings QTY",
    //   headerTooltip: "Total Video Device Bookings QTY (Last 24 Months)",
    // },
    // {
    //   headerName: "Total Video Device Bookings $$ (Last 3 Years)",
    //   field: "videoDeviceAmount3Y",
    //   colId: "videoDeviceAmount3Y",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     6;
    //     return currencyFormatter(data?.videoDeviceAmount3Y ?? 0) ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings $$",
    //   headerTooltip: "Total Video Device Bookings $$ (Last 3 Years)",
    // },
    // {
    //   headerName: "Total Video Device Bookings QTY (Last 3 Years)",
    //   field: "videoDeviceQty3Y",
    //   colId: "videoDeviceQty3Y",
    //   valueGetter: (params) => {
    //     if (params.node.rowPinned) {
    //       return "";
    //     }
    //     const data: Account | null = params.data;
    //     return data?.videoDeviceQty3Y?.toLocaleString() ?? "N/A";
    //   },
    //   filter: "DeviceFilter",
    //   groupHeader: "Device",
    //   subGroupHeader: "Total Video Device Bookings QTY",
    //   headerTooltip: "Total Video Device Bookings QTY (Last 3 Years)",
    // },
    // total devices
    {
      headerName: "Total Device Bookings $$ (Last 6 Months)",
      field: "deviceAmount6M",
      colId: "deviceAmount6M",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      // valueGetter: (params) => {
      //   if (params.node.rowPinned) {
      //     return "";
      //   }
      //   const data: Account | null = params.data;
      //   return currencyFormatter(data?.deviceAmount6M ?? 0) ?? "N/A";
      // },
      cellRenderer: "AmountRenderer",
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings $$",
      headerTooltip: "Total Device Bookings $$ (Last 6 Months)",
    },
    {
      headerName: "Total Device Bookings QTY (Last 6 Months)",
      field: "deviceQty6M",
      colId: "deviceQty6M",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return data?.deviceQty6M?.toLocaleString() ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings QTY",
      headerTooltip: "Total Device Bookings QTY (Last 6 Months)",
    },
    {
      headerName: "Total Device Bookings $$ (Last 12 Months)",
      field: "deviceAmount12M",
      colId: "deviceAmount12M",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      // valueGetter: (params) => {
      //   if (params.node.rowPinned) {
      //     return "";
      //   }
      //   const data: Account | null = params.data;
      //   return currencyFormatter(data?.deviceAmount12M ?? 0) ?? "N/A";
      // },
      cellRenderer: "AmountRenderer",
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings $$",
      headerTooltip: "Total Device Bookings $$ (Last 12 Months)",
    },
    {
      headerName: "Total Device Bookings QTY (Last 12 Months)",
      field: "deviceQty12M",
      colId: "deviceQty12M",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return data?.deviceQty12M?.toLocaleString() ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings QTY",
      headerTooltip: "Total Device Bookings QTY (Last 12 Months)",
    },
    {
      headerName: "Total Device Bookings $$ (Last 24 Months)",
      field: "deviceAmount24M",
      colId: "deviceAmount24M",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      // valueGetter: (params) => {
      //   if (params.node.rowPinned) {
      //     return "";
      //   }
      //   const data: Account | null = params.data;
      //   return currencyFormatter(data?.deviceAmount24M ?? 0) ?? "N/A";
      // },
      cellRenderer: "AmountRenderer",
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings $$",
      headerTooltip: "Total Device Bookings $$ (Last 24 Months)",
    },
    {
      headerName: "Total Device Bookings QTY (Last 24 Months)",
      field: "deviceQty24M",
      colId: "deviceQty24M",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return data?.deviceQty24M?.toLocaleString() ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings QTY",
      headerTooltip: "Total Device Bookings QTY (Last 24 Months)",
    },
    {
      headerName: "Total Device Bookings $$ (Last 3 Years)",
      field: "deviceAmount3Y",
      colId: "deviceAmount3Y",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      // valueGetter: (params) => {
      //   if (params.node.rowPinned) {
      //     return "";
      //   }
      //   const data: Account | null = params.data;
      //   6;
      //   return currencyFormatter(data?.deviceAmount3Y ?? 0) ?? "N/A";
      // },
      cellRenderer: "AmountRenderer",
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings $$",
      headerTooltip: "Total Device Bookings $$ (Last 3 Years)",
    },
    {
      headerName: "Total Device Bookings QTY (Last 3 Years)",
      field: "deviceQty3Y",
      colId: "deviceQty3Y",
      headerClass: [`${styles.customDetailsSecond}`, "cell_new_indicator"],
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return data?.deviceQty3Y?.toLocaleString() ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Total Device Bookings QTY",
      headerTooltip: "Total Device Bookings QTY (Last 3 Years)",
    },
    {
      headerName: "Registered Device Cloud (Last 6 Months)",
      field: "adoptionCloud6M",
      colId: "adoptionCloud6M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionCloud6M, params?.data, "6M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Cloud",
      headerTooltip: "Registered Device Cloud (Last 6 Months)",
    },
    {
      headerName: "Registered Device Cloud (Last 12 Months)",
      field: "adoptionCloud12M",
      colId: "adoptionCloud12M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionCloud12M, params?.data, "12M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Cloud",
      headerTooltip: "Registered Device Cloud (Last 12 Months)",
    },
    {
      headerName: "Registered Device Cloud (Last 24 Months)",
      field: "adoptionCloud24M",
      colId: "adoptionCloud24M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionCloud24M, params?.data, "24M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Cloud",
      headerTooltip: "Registered Device Cloud (Last 24 Months)",
    },
    {
      headerName: "Registered Device Cloud (Last 3 Years)",
      field: "adoptionCloud3Y",
      colId: "adoptionCloud3Y",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionCloud3Y, params?.data, "3Y");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Cloud",
      headerTooltip: "Registered Device Cloud (Last 3 Years)",
    },
    {
      headerName: "Registered Device Edge (Last 6 Months)",
      field: "adoptionEdge6M",
      colId: "adoptionEdge6M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionEdge6M, params?.data, "6M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Edge",
      headerTooltip: "Registered Device Edge (Last 6 Months)",
    },
    {
      headerName: "Registered Device Edge (Last 12 Months)",
      field: "adoptionEdge12M",
      colId: "adoptionEdge12M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionEdge12M, params?.data, "12M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Edge",
      headerTooltip: "Registered Device Edge (Last 12 Months)",
    },
    {
      headerName: "Registered Device Edge (Last 24 Months)",
      field: "adoptionEdge24M",
      colId: "adoptionEdge24M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionEdge24M, params?.data, "24M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Edge",
      headerTooltip: "Registered Device Edge (Last 24 Months)",
    },
    {
      headerName: "Registered Device Edge (Last 3 Years)",
      field: "adoptionEdge3Y",
      colId: "adoptionEdge3Y",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionEdge3Y, params?.data, "3Y");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Edge",
      headerTooltip: "Registered Device Edge (Last 3 Years)",
    },
    {
      headerName: "Registered Device Not Yet On Cloud (Last 6 Months)",
      field: "adoptionUnknown6M",
      colId: "adoptionUnknown6M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionUnknown6M, params?.data, "6M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Not Yet On Cloud",
      headerTooltip: "Registered Device Not Yet On Cloud (Last 6 Months)",
    },
    {
      headerName: "Registered Device Not Yet On Cloud (Last 12 Months)",
      field: "adoptionUnknown12M",
      colId: "adoptionUnknown12M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionUnknown12M, params?.data, "12M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Not Yet On Cloud",
      headerTooltip: "Registered Device Not Yet On Cloud (Last 12 Months)",
    },
    {
      headerName: "Registered Device Not Yet On Cloud (Last 24 Months)",
      field: "adoptionUnknown24M",
      colId: "adoptionUnknown24M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionUnknown24M, params?.data, "24M");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Not Yet On Cloud",
      headerTooltip: "Registered Device Not Yet On Cloud (Last 24 Months)",
    },
    {
      headerName: "Registered Device Not Yet On Cloud (Last 3 Years)",
      field: "adoptionUnknown3Y",
      colId: "adoptionUnknown3Y",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return handleAdoptionPercent(params?.data?.adoptionUnknown3Y, params?.data, "3Y");
      },
      filter: "DeviceFilter",
      filterParams: {
        showPercent: true,
      },
      groupHeader: "Device",
      subGroupHeader: "Registered Device Not Yet On Cloud",
      headerTooltip: "Registered Device Not Yet On Cloud (Last 3 Years)",
    },
    {
      headerName: "Cloud Video Device Bookings $$ (Last 6 Months)",
      field: "videoDeviceCloudAmount6M",
      colId: "videoDeviceCloudAmount6M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.videoDeviceCloudAmount6M ?? 0) ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Cloud Video Device Bookings $$",
      headerTooltip: "Cloud Video Device Bookings $$ (Last 6 Months)",
    },
    {
      headerName: "Cloud Video Device Bookings $$ (Last 12 Months)",
      field: "videoDeviceCloudAmount12M",
      colId: "videoDeviceCloudAmount12M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.videoDeviceCloudAmount12M ?? 0) ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Cloud Video Device Bookings $$",
      headerTooltip: "Cloud Video Device Bookings $$ (Last 12 Months)",
    },
    {
      headerName: "Cloud Video Device Bookings $$ (Last 24 Months)",
      field: "videoDeviceCloudAmount24M",
      colId: "videoDeviceCloudAmount24M",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.videoDeviceCloudAmount24M ?? 0) ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Cloud Video Device Bookings $$",
      headerTooltip: "Cloud Video Device Bookings $$ (Last 24 Months)",
    },
    {
      headerName: "Cloud Video Device Bookings $$ (Last 3 Years)",
      field: "videoDeviceCloudAmount3Y",
      colId: "videoDeviceCloudAmount3Y",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.videoDeviceCloudAmount3Y ?? 0) ?? "N/A";
      },
      filter: "DeviceFilter",
      groupHeader: "Device",
      subGroupHeader: "Cloud Video Device Bookings $$",
      headerTooltip: "Cloud Video Device Bookings $$ (Last 3 Years)",
    },
    /* {
      headerName: "WEM Meeting",
      field: "wemMeeting",
      colId: "wemMeeting",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemMeeting ?? "";
        return data;
      },
      cellRenderer: "CoverageStatusRenderer",
      cellRendererParams: {
        type: "workload",
      },
      cellClass: ["ag-react-container-full-height"],
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "coverage-status",
        axios,
        nameKey: "name",
        key: "value",
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Meeting Exception Reason",
      field: "wemMeetingExpReason",
      colId: "wemMeetingExpReason",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemMeetingExpReason ?? "N/A";
        return data;
      },
      cellRenderer: "ReasonRenderer",
      cellRendererParams: {
        type: "workload",
      },
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "not null" },
          { label: "No", value: "null" },
        ],
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Meeting Exception By",
      field: "wemMeetingExpBy",
      colId: "wemMeetingExpBy",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemMeetingExpBy ?? "N/A";
        return data;
      },
      filter: false,
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Meeting Exception Date",
      field: "wemMeetingExpDate",
      colId: "wemMeetingExpDate",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return params?.data?.wemMeetingExpDate
          ? moment(params?.data?.wemMeetingExpDate).format("MM/DD/YYYY")
          : "N/A";
      },
      comparator: (a, b) => moment(a).diff(moment(b)),
      filter: "DatePickerFilter",
      filterParams: {
        orInNextDisplay: false,
      },
      groupHeader: "Engagement Model",
    }, */
    /*  {
      headerName: "WEM Calling Cloud",
      field: "wemCallingCloud",
      colId: "wemCallingCloud",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemCallingCloud ?? "";
        return data;
      },
      cellRenderer: "CoverageStatusRenderer",
      cellRendererParams: {
        type: "workload",
      },
      cellClass: ["ag-react-container-full-height"],
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "coverage-status",
        axios,
        nameKey: "name",
        key: "value",
      },
      groupHeader: "Engagement Model",
    }, */
    /* {
      headerName: "WEM Calling Cloud Exception Reason",
      field: "wemCallingCloudExpReason",
      colId: "wemCallingCloudExpReason",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null =
          params.data?.wemCallingCloudExpReason ?? "N/A";
        return data;
      },
      cellRenderer: "ReasonRenderer",
      cellRendererParams: {
        type: "workload",
      },
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "not null" },
          { label: "No", value: "null" },
        ],
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Calling Cloud Exception By",
      field: "wemCallingCloudExpBy",
      colId: "wemCallingCloudExpBy",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemCallingCloudExpBy ?? "N/A";
        return data;
      },
      filter: false,
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Calling Cloud Exception Date",
      field: "wemCallingCloudExpDate",
      colId: "wemCallingCloudExpDate",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return params?.data?.wemCallingCloudExpDate
          ? moment(params?.data?.wemCallingCloudExpDate).format("MM/DD/YYYY")
          : "N/A";
      },
      filter: "DatePickerFilter",
      filterParams: {
        orInNextDisplay: false,
      },
      groupHeader: "Engagement Model",
    }, */
    {
      headerName: "Cloud Suite Bundle WEM",
      field: "wemSuite",
      colId: "wemSuite",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemSuite ?? "";
        return data;
      },
      cellRenderer: "CoverageStatusRenderer",
      cellRendererParams: {
        type: "workload",
      },
      cellClass: ["ag-react-container-full-height"],
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "coverage-status-nonfed",
        axios,
        nameKey: "name",
        key: "value",
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "Cloud Suite Bundle WEM Exception Reason",
      field: "wemSuiteExpReason",
      colId: "wemSuiteExpReason",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemSuiteExpReason ?? "N/A";
        return data;
      },
      cellRenderer: "ReasonRenderer",
      cellRendererParams: {
        type: "workload",
      },
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "not null" },
          { label: "No", value: "null" },
        ],
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "Cloud Suite Bundle WEM Exception By",
      field: "wemSuiteExpBy",
      colId: "wemSuiteExpBy",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemSuiteExpBy ?? "N/A";
        return data;
      },
      filter: false,
      groupHeader: "Engagement Model",
    },
    {
      headerName: "Cloud Suite Bundle WEM Exception Date",
      field: "wemSuiteExpDate",
      colId: "wemSuiteExpDate",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return params?.data?.wemSuiteExpDate
          ? moment(params?.data?.wemSuiteExpDate).format("MM/DD/YYYY")
          : "N/A";
      },
      filter: "DatePickerFilter",
      filterParams: {
        orInNextDisplay: false,
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Calling On-Prem",
      field: "wemCallingOnPrem",
      colId: "wemCallingOnPrem",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemCallingOnPrem ?? "";
        return data;
      },
      cellRenderer: "CoverageStatusRenderer",
      cellRendererParams: {
        type: "workload",
      },
      cellClass: ["ag-react-container-full-height"],
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "coverage-status-nonfed",
        axios,
        nameKey: "name",
        key: "value",
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Contact Center",
      field: "wemContactCenter",
      colId: "wemContactCenter",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemContactCenter ?? "";
        return data;
      },
      cellRenderer: "CoverageStatusRenderer",
      cellRendererParams: {
        type: "workload",
      },
      cellClass: ["ag-react-container-full-height"],
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "coverage-status-nonfed",
        axios,
        nameKey: "name",
        key: "value",
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Contact Center Exception Reason",
      field: "wemContactCenterExpReason",
      colId: "wemContactCenterExpReason",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemContactCenterExpReason ?? "N/A";
        return data;
      },
      cellRenderer: "ReasonRenderer",
      cellRendererParams: {
        type: "workload",
      },
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "not null" },
          { label: "No", value: "null" },
        ],
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Contact Center Exception By",
      field: "wemContactCenterExpBy",
      colId: "wemContactCenterExpBy",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemContactCenterExpBy ?? "N/A";
        return data;
      },
      filter: false,
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Contact Center Exception Date",
      field: "wemContactCenterExpDate",
      colId: "wemContactCenterExpDate",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return params?.data?.wemContactCenterExpDate
          ? moment(params?.data?.wemContactCenterExpDate).format("MM/DD/YYYY")
          : "N/A";
      },
      filter: "DatePickerFilter",
      filterParams: {
        orInNextDisplay: false,
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Video Device",
      field: "wemVideoDevice",
      colId: "wemVideoDevice",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemVideoDevice ?? "";
        return data;
      },
      cellRenderer: "CoverageStatusRenderer",
      cellRendererParams: {
        type: "workload",
      },
      cellClass: ["ag-react-container-full-height"],
      filter: "CheckboxFilter",
      filterParams: {
        queryParams: "coverage-status-nonfed",
        axios,
        nameKey: "name",
        key: "value",
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Video Device Exception Reason",
      field: "wemVideoDeviceExpReason",
      colId: "wemVideoDeviceExpReason",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemVideoDeviceExpReason ?? "N/A";
        return data;
      },
      cellRenderer: "ReasonRenderer",
      cellRendererParams: {
        type: "workload",
      },
      filter: "RadioFilter",
      filterParams: {
        radioData: [
          { label: "Yes", value: "not null" },
          { label: "No", value: "null" },
        ],
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Video Device Exception By",
      field: "wemVideoDeviceExpBy",
      colId: "wemVideoDeviceExpBy",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.wemVideoDeviceExpBy ?? "N/A";
        return data;
      },
      filter: false,
      groupHeader: "Engagement Model",
    },
    {
      headerName: "WEM Video Device Exception Date",
      field: "wemVideoDeviceExpDate",
      colId: "wemVideoDeviceExpDate",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return params?.data?.wemVideoDeviceExpDate
          ? moment(params?.data?.wemVideoDeviceExpDate).format("MM/DD/YYYY")
          : "N/A";
      },
      filter: "DatePickerFilter",
      filterParams: {
        orInNextDisplay: false,
      },
      groupHeader: "Engagement Model",
    },
    {
      headerName: "Reseller Name & ID",
      field: "resellerInfo",
      colId: "resellerInfo",
      sortable: true,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        const data: Account | null = params.data?.resellerInfo ?? "N/A";
        return data;
      },
      filter: false,
      groupHeader: "Customer",
    },
    {
      headerName: "Reseller Id",
      field: "resellerId",
      colId: "resellerId",
      suppressColumnsToolPanel: true,
      hide: true,
      lockVisible: true,
      filter: "ResellerFilter",
      filterParams: {
        customPath: "/api/dataservice/v1/metadata/resellerInfo?type=resellerId",
        axios,
        nameKey: "name",
        nullOptionName: "None",
      },
    },
    {
      headerName: "Reseller",
      field: "reseller",
      colId: "reseller",
      suppressColumnsToolPanel: true,
      hide: true,
      lockVisible: true,
      filter: "ResellerFilter",
      filterParams: {
        customPath: "/api/dataservice/v1/metadata/resellerInfo?type=reseller",
        axios,
        nameKey: "name",
        nullOptionName: "None",
      },
    },
    {
      headerName: "Lifecycle Stage by Workload",
      headerComponentParams: {
        template: `
              <div class="ag-cell-label-container" role="presentation">
                <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span class="ag-header-cell-text" role="columnheader">Lifecycle Stage by Workload</span>
            </div>
            </div>
              `,
        icon: "fa fa-user",
      },
      colId: "lifecycleStageByWorkload",
      field: "lifecycleStageByWorkload",
      sortable: false,
      cellRenderer: "SubscriptionRenderer",
      cellRendererParams: {
        fieldKey: "lifecycleStageByWorkload",
        mappings: factorMappings,
      },
      valueGetter: (params) => {
        const subscriptions: SubscriptionType[] = (params.data?.subscriptions ?? []).filter(
          (s: SubscriptionType) => s.lifecycleStageByWorkload.length > 0
        );
        if (subscriptions.length === 0) {
          return "N/A";
        } else if (subscriptions.length === 1) {
          return subscriptions[0].lifecycleStageByWorkload.join(", ");
        } else {
          return subscriptions.reduce((txt, curr) => {
            txt += `${curr.subscriptionId} - ${curr.lifecycleStageByWorkload.join(", ")}\n`;
            return txt;
          }, "");
        }
      },
      filter: "WorkloadFilter",
      filterParams: {
        workloadCategory: workloadCategory,
        workloadStage: workloadStage,
      },
    },
    {
      headerName: "AOV (Cloud Meetings + Messaging)",
      field: "aovMeetingMsgCloud",
      colId: "aovMeetingMsgCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovMeetingMsgCloud = 0 } = params.data;
          return `$${aovMeetingMsgCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovMeetingMsgCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (On-Prem Meetings + Messaging)",
      field: "aovMeetingMsgOnPrem",
      colId: "aovMeetingMsgOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovMeetingMsgOnPrem = 0 } = params.data;
          return `$${aovMeetingMsgOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        const data: Account | null = params.data;
        if (data?.aovMeetingMsgOnPrem) {
          return currencyFormatter(data?.aovMeetingMsgOnPrem);
        }
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (Cloud Calling)",
      field: "aovCallingCloud",
      colId: "aovCallingCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCallingCloud = 0 } = params.data;
          return `$${aovCallingCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovCallingCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (On-Prem Calling)",
      field: "aovCallingOnPrem",
      colId: "aovCallingOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCallingOnPrem = 0 } = params.data;
          return `$${aovCallingOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovCallingOnPrem);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (Cloud Contact Center)",
      field: "aovContactCenterCloud",
      colId: "aovContactCenterCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovContactCenterCloud = 0 } = params.data;
          return `$${aovContactCenterCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovContactCenterCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (Webex Contact Center)",
      field: "aovCloudWXCC",
      colId: "aovCloudWXCC",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      sortable: true,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCloudWXCC = 0 } = params.data;
          return `$${aovCloudWXCC?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovCloudWXCC);
      },
      // toolPanelClass: ["skip_visiable_check"],
      subGroupHead: "AOV (Cloud Contact Center)",
      groupHeader: "AOV",
      groupIndex: 5,
    },
    {
      headerName: "AOV (Webex Contact Center Enterprise)",
      field: "aovCloudWXCCE",
      colId: "aovCloudWXCCE",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCloudWXCCE = 0 } = params.data;
          return `$${aovCloudWXCCE?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovCloudWXCCE);
      },
      toolPanelClass: ["skip_visiable_check"],
      subGroupHeader: "AOV (Cloud Contact Center)",
    },
    {
      headerName: "AOV (Webex Contact Center Add-Ons)",
      field: "aovCloudWXCCAddon",
      colId: "aovCloudWXCCAddon",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCloudWXCCAddon = 0 } = params.data;
          return `$${aovCloudWXCCAddon?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovCloudWXCCAddon);
      },
      toolPanelClass: ["skip_visiable_check"],
      subGroupHeader: "AOV (Cloud Contact Center)",
    },
    {
      headerName: "AOV (Webex Contact Center Digital Channels)",
      field: "aovCloudWXCCDC",
      colId: "aovCloudWXCCDC",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCloudWXCCDC = 0 } = params.data;
          return `$${aovCloudWXCCDC?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovCloudWXCCDC);
      },
      toolPanelClass: ["skip_visiable_check"],
      subGroupHeader: "AOV (Cloud Contact Center)",
    },
    {
      headerName: "AOV (On-Prem Contact Center)",
      field: "aovContactCenterOnPrem",
      colId: "aovContactCenterOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovContactCenterOnPrem = 0 } = params.data;
          return `$${aovContactCenterOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovContactCenterOnPrem);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (Cloud Devices)",
      field: "aovDeviceCloud",
      colId: "aovDeviceCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovDeviceCloud = 0 } = params.data;
          return `$${aovDeviceCloud?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovDeviceCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (On-Prem Devices)",
      field: "aovDeviceOnPrem",
      colId: "aovDeviceOnPrem",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovDeviceOnPrem = 0 } = params.data;
          return `$${aovDeviceOnPrem?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovDeviceOnPrem);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "AOV (Webex Suite)",
      field: "aovSuiteCustom",
      colId: "aovSuiteCustom",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      groupHeader: "AOV",
      groupIndex: 20,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: SUIT_AOV_COLLECTION_COLUMN,
        type: "aov",
      },

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovSuiteCustom = 0 } = params.data;
          return `$${aovSuiteCustom?.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        }
        return currencyFormatter(params.data?.aovSuiteCustom);
      },
      headerTooltip: `<p style="line-height: 16px;font-size:12px">Sum of ARR of all the post offer attribution and post adjustment annual recurring revenue (ARR) of all products except Technical Support that are part of the Webex Suite offer under a given subscription.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                    <div class="ag-cell-label-container" role="presentation">
                      <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                      <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                        <span class="ag-header-cell-text" role="columnheader">AOV</span>
                        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                        <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                      </div>
                      <div style="position: absolute;
                      bottom: 6px;
                      left: 25px;
                      color: #00A0D1;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      font-size: 9px;">Webex Suite (Excludes Technical Support)<div>
                  </div>
                  </div>
                    `,
      },
    },
    {
      headerName: "AOV (Collab + Non-Collab)",
      groupHeader: "AOV",
      groupIndex: 8,
      field: "aovTotal",
      colId: "aovTotal",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "InvoiceMrrArrRenderer",
      cellRendererParams: { type: "aov", label: "ARR" },

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovTotal = 0 } = params.data;
          return aovTotal;
        }
        const data: Account | null = params.data;
        return data?.aovTotal;
      },
      headerTooltip: `<p style="line-height: 16px;font-size:12px">Sum of all the post offer attribution and post adjustment annual recurring revenue (ARR) of products or services (SKU) under a given subscription that are considered as 'Collaboration' and 'Non-Collaboration' revenue by Cisco Finance. Security and Technical Support Services is <b>not</b> considered as 'Collaboration' recurring revenue.${invoiceTooltip}</p>`,
      headerComponentParams: {
        template: `
                  <div class="ag-cell-label-container" role="presentation">
                    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                      <span class="ag-header-cell-text" role="columnheader">AOV</span>
                      <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                      <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                      <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                      <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                      <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                    </div>
                    <div style="position: absolute;
                    bottom: 6px;
                    left: 25px;
                    color: #00A0D1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 9px;
                    width: -webkit-fill-available;">(Collab + Non-Collab)<div>
                </div>
                </div>
                  `,
      },
    },
    {
      headerName: "AOV (Collab)",
      field: "aovCollab",
      colId: "aovCollab",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      groupHeader: "AOV",
      groupIndex: 6,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [...AOV_COLLAB_COLLECTION_COLUMN, ...BREAK_UP_AOV_CLOUD_CONTACT_CENTER_COLUMN],
        type: "aov",
      },

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCollab = 0 } = params.data;
          return aovCollab;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.aovCollab ?? 0);
      },
      headerComponentParams: {
        template: `
                    <div class="ag-cell-label-container" role="presentation">
                      <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                      <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                        <span class="ag-header-cell-text" role="columnheader">AOV</span>
                        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                        <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                      </div>
                      <div style="position: absolute;
                      bottom: 6px;
                      left: 25px;
                      color: #00A0D1;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      font-size: 9px;">(Collab)<div>
                  </div>
                  </div>
                    `,
      },
    },
    {
      headerName: "AOV (Non-Collab)",
      field: "aovNonCollab",
      colId: "aovNonCollab",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      groupHeader: "AOV",
      groupIndex: 7,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: { collection: [], type: "aov" },

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovNonCollab = 0 } = params.data;
          return aovNonCollab;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.aovNonCollab ?? 0);
      },
      headerComponentParams: {
        template: `
                      <div class="ag-cell-label-container" role="presentation">
                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                          <span class="ag-header-cell-text" role="columnheader">AOV</span>
                          <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                          <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                          <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                          <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                          <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                        </div>
                        <div style="position: absolute;
                        bottom: 6px;
                        left: 25px;
                        color: #00A0D1;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 9px;">(Non-Collab)<div>
                    </div>
                    </div>
                      `,
      },
    },
    {
      headerName: "AOV (On-Prem + Cloud)",
      field: "aovOnPremAndCloud",
      colId: "aovOnPremAndCloud",
      authKey: "aovOnPrem",
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [
          ...AOV_ONPREM_COLLECTION_COLUMN,
          ...AOV_CLOUD_COLLECTION_COLUMN,
          ...BREAK_UP_AOV_CLOUD_CONTACT_CENTER_COLUMN,
        ],
        type: "aov",
      },
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      groupHeader: "AOV",
      groupIndex: 5,
      sortable: true,
      sortingOrder: ["desc", "asc", null],

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovOnPremAndCloud = 0 } = params.data;
          return aovOnPremAndCloud;
        }
        const data: Account | null = params.data;
        return currencyFormatter((data?.aovOnPrem || 0) + (data?.aovCloud || 0));
      },
      headerComponentParams: {
        template: `
                          <div class="ag-cell-label-container" role="presentation">
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                              <span class="ag-header-cell-text" role="columnheader">AOV</span>
                              <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                              <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                              <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                              <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                              <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                            </div>
                            <div style="position: absolute;
                            bottom: 6px;
                            left: 25px;
                            color: #00A0D1;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            font-size: 9px;">(On-Prem + Cloud)<div>
                        </div>
                        </div>
                          `,
      },
    },
    {
      headerName: "AOV (On-Prem + Cloud - CPAAS)",
      field: "aovNoCPass",
      colId: "aovNoCPass",
      authKey: "aovOnPrem",
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [
          ...AOV_ONPREM_COLLECTION_COLUMN,
          ...AOV_CLOUD_COLLECTION_COLUMN.filter((c) => c !== "aovCPassCloud"),
          ...BREAK_UP_AOV_CLOUD_CONTACT_CENTER_COLUMN,
        ],
        type: "aov",
      },
      filter: "NumberFilter",
      filterParams: { showBlank: false, buttons: ["apply", "reset"] },
      groupHeader: "AOV",
      groupIndex: 5,
      sortable: true,
      sortingOrder: ["desc", "asc", null],

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovNoCPass = 0 } = params.data;
          return aovNoCPass;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.aovNoCPass || 0);
      },
      headerComponentParams: {
        template: `
                          <div class="ag-cell-label-container" role="presentation">
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                              <span class="ag-header-cell-text" role="columnheader">AOV</span>
                              <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                              <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                              <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                              <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                              <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                            </div>
                            <div style="position: absolute;
                            bottom: 6px;
                            left: 25px;
                            color: #00A0D1;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            font-size: 9px;">(Excludes CPAAS)<div>
                        </div>
                        </div>
                          `,
      },
    },
    {
      headerName: "AOV (On-Prem)",
      field: "aovOnPrem",
      colId: "aovOnPrem",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: AOV_ONPREM_COLLECTION_COLUMN,
        type: "aov",
      },
      groupHeader: "AOV",
      groupIndex: 3,
      sortable: true,
      sortingOrder: ["desc", "asc", null],

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovOnPrem = 0 } = params.data;
          return aovOnPrem;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.aovOnPrem ?? 0);
      },
      headerComponentParams: {
        template: `
                        <div class="ag-cell-label-container" role="presentation">
                          <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                          <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                            <span class="ag-header-cell-text" role="columnheader">AOV</span>
                            <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                            <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                            <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                            <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                            <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                          </div>
                          <div style="position: absolute;
                          bottom: 6px;
                          left: 25px;
                          color: #00A0D1;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          font-size: 9px;">(On-Prem)<div>
                      </div>
                      </div>
                        `,
      },
    },
    {
      headerName: "AOV (Cloud)",
      field: "aovCloud",
      colId: "aovCloud",
      cellRenderer: "StaticCollectionRevenueCellRenderer",
      cellRendererParams: {
        collection: [...AOV_CLOUD_COLLECTION_COLUMN, ...BREAK_UP_AOV_CLOUD_CONTACT_CENTER_COLUMN],
        type: "aov",
      },
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      groupHeader: "AOV",
      groupIndex: 4,
      sortable: true,
      sortingOrder: ["desc", "asc", null],

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          const { aovCloud = 0 } = params.data;
          return aovCloud;
        }
        const data: Account | null = params.data;
        return currencyFormatter(data?.aovCloud ?? 0);
      },
      headerComponentParams: {
        template: `
                        <div class="ag-cell-label-container" role="presentation">
                          <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                          <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                            <span class="ag-header-cell-text" role="columnheader">AOV</span>
                            <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                            <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                            <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                            <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                            <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                          </div>
                          <div style="position: absolute;
                          bottom: 6px;
                          left: 25px;
                          color: #00A0D1;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          font-size: 9px;">(Cloud)<div>
                      </div>
                      </div>
                        `,
      },
    },
    {
      headerName: "AOV (Cloud - CPAAS GPL)",
      field: "aovCPassCloud",
      colId: "aovCPassCloud",
      filter: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      lockVisible: true,
      sortable: false,

      valueGetter: (params: any) => {
        return currencyFormatter(params.data?.aovCPassCloud);
      },
      toolPanelClass: ["skip_visiable_check"],
    },
    {
      headerName: "Organization AOV (Collab + Non-Collab)",
      field: "aovOrgTotal",
      colId: "aovOrgTotal",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      groupHeader: "AOV",
      groupIndex: 7,
      hide: true,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      cellRenderer: "OrganizationInvoiceArrCellRenderer",

      valueGetter: (params: any) => {
        if (params.node.rowPinned) {
          return "-";
        }
        const data: Account | null = params.data;
        if (data?.aovOrgTotal !== null) {
          return currencyFormatter(data?.aovOrgTotal);
        }
      },
      headerTooltip: `<ul><li style="line-height: 1.2">It shows the sum of AOV (Collab + non-Collab) for all the accounts under the same organization.</li>
    <li style="line-height: 1.2">Case when the Organization has both ‘Active’ and ‘Inactive’ accounts, then the system will only consider and calculate the ARR for all the ‘Active’ accounts under that organization.</li>
    <li style="line-height: 1.2">Case when all accounts under the Organization are 'Inactive', then the system will consider and calculate the ARR of last 'Active' subscriptions for each account under the organization.</li></ul>`,
      headerComponentParams: {
        template: `
                      <div class="ag-cell-label-container" role="presentation">
                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                          <span class="ag-header-cell-text" role="columnheader">Organization AOV</span>
                          <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                          <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                          <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                          <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                          <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                        </div>
                        <div style="position: absolute;
                        bottom: 6px;
                        left: 25px;
                        color: #00A0D1;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 9px;">(Collab + Non-Collab)<div>
                    </div>
                    </div>
                      `,
      },
    },
    {
      headerName: "Custom AOV/Bookings",
      field: "aovCustom",
      colId: "aovCustom",
      authKey: "aovMeetingMsgOnPrem",
      filter: "NumberFilter",
      filterParams: { showBlank: false },
      cellRenderer: "CollectionRevenueCellRenderer",
      cellRendererParams: { collection: AOV_COLLECTION_COLUMN, type: "aov" },
      groupHeader: "AOV",
      groupIndex: 10,
      sortable: true,
      sortingOrder: ["desc", "asc", null],
      headerComponent: "CollectionRevenueCellHeader",
      headerComponentParams: {
        collection: AOV_COLLECTION_COLUMN,
        type: "aov",
      },
      enableCellChangeFlash: false,
      headerClass: "ag-react-container-full-width ",
    },
  ];

  // if (embedded) {
  //   columnDef.push({
  //     headerName: "Activity Created?",
  //     field: "attributes",
  //     colId: "attributes",
  //     sortable: false,
  //     filter: "RadioFilter",
  //     filterParams: {
  //       radioData: [
  //         { label: "Yes", value: "equals" },
  //         { label: "No", value: "notEquals" },
  //       ],
  //       getCustomValue: () => document.getElementsByName("playbookId")?.[0]?.id,
  //     },
  //     pinned: "left",
  //     suppressFiltersToolPanel: false,
  //     suppressColumnsToolPanel: true,
  //     width: 169,
  //     lockPinned: true,
  //     lockPosition: true,
  //     cellRenderer: "ActivityAlreadyRenderer",
  //     valueGetter: (params: ValueGetterParams) => {
  //       if (params.node.rowPinned) {
  //         return "";
  //       }
  //       const data: Account | undefined = params.data;
  //       return data?.attributes?.latestActivity?.activityStatus ?? "";
  //     },
  //     headerTooltip:
  //       "Shows if an activity is already created for the respective account from the selected template. And if yes, it shows the current activity status.",
  //   });
  // }

  if ([ROLE.CCSE_ROLE, ROLE.DEV_ROLE].includes(authDetail?.role)) {
    columnDef.push({
      headerName: "WSMP Status",
      field: "ccseJira",
      colId: "ccseJira",
      sortable: false,
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return "";
        }
        return params?.data?.ccseJira;
      },
      filter: false,
      cellRenderer: "WSMPStatusRenderer",
      headerTooltip:
        "Number of Sites with Yes WSMP flag/Total Number of Sites, All sites are under the Control Hub Org IDs which are associated to account",
    });
  }

  return {
    columnDefs: columnDef,
    defaultColDef: {
      width: 169,
      minWidth: 100,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      resizable: true,
      sortable: true,
      unSortIcon: true,
      filter: false,
      menuTabs: ["generalMenuTab", "columnsMenuTab", "filterMenuTab"],
      filterParams: {
        buttons: ["reset", "apply"],
        suppressAndOrCondition: true,
        filterOptions: ["contains"],
        newRowsAction: "keep",
      },
    },
    enableRangeSelection: true,
    headerHeight: ROW_HEADER_HEIGHT,
    rowSelection: "multiple",
    rowHeight: ROW_HEIGHT,
    suppressCsvExport: true,
    suppressExcelExport: true,
    suppressRowClickSelection: true,
    tooltipShowDelay: 0,
    // tooltipHideDelay:60000,
    pinnedBottomRowData: [],
    // if FF brower, then set scrollbarWidth
    scrollbarWidth: handleFFHorizontalScrollbar(),
    getRowStyle: (params: any) => {
      if (params.node.rowPinned && params.data.status) {
        return { background: "#F8F9FB", border: "0px" };
      }
    },
    groupRowInnerRenderer: "GroupRenderer",
    groupRowRendererParams: {
      groupCol,
    },
    onGridReady: (params) => {
      const dataSource = ServerSideDatasource({
        axios,
        authDetail,
        embedded,
        setCollectionColumns,
        setAOVCollectionColumns,
        setExpandedGroups,
        cavBuId,
        ciscoCsmId,
        fixedAccountId,
        preSelected,
        setTotalSelect,
        showAOV,
      });
      const gridApi = params.api;
      // saved search in localStorage
      const localFilter = localStorage.getItem(PORTFOLIO_LAST_SEARCH_KEY);
      const localSort = localStorage.getItem(PORTFOLIO_LAST_SORT_KEY);
      if (!!localSort) {
        const savedSort = JSON.parse(localSort);
        gridApi.setSortModel(savedSort);
      }
      if (Object.keys(processFilterFromURL(gridApi, params.columnApi, false, false)).length > 0) {
      } else if (!!localFilter) {
        const savedFilter = JSON.parse(localFilter);
        gridApi.setFilterModel(savedFilter);
      }

      setGridEvent(params);
      // prevent call twice
      setTimeout(() => {
        gridApi.setServerSideDatasource(dataSource);
      }, 500);

      gridApi.addEventListener("filterChanged", (e: any) => {
        const api: GridApi = e.api;
        const filterModels = api.getFilterModel();
        const { externalAlertFilter: _externalAlertFilter, ...filterModel } = filterModels;
        localStorage.setItem(PORTFOLIO_LAST_SEARCH_KEY, JSON.stringify(filterModel));
        handleAgGridFilterIcon(api);
      });

      gridApi.addEventListener("sortChanged", (e: any) => {
        const api: GridApi = e.api;
        localStorage.setItem(PORTFOLIO_LAST_SORT_KEY, JSON.stringify(api.getSortModel()));
        api.ensureIndexVisible(0, "top");
      });
      // addColumnsSelectLabel();
    },
    // onColumnMoved: (params) =>
    //   savingColumnState(params, PORTFOLIO_COLUMN_STATE_KEY),
    // onColumnVisible: (params) => {
    //   savingColumnState(params, PORTFOLIO_COLUMN_STATE_KEY);
    //   amountVisibleCheck(params, showAOV);
    //   // columnVisiableWatcher(params);
    // },
    // onColumnResized: (params) =>
    //   savingColumnState(params, PORTFOLIO_COLUMN_STATE_KEY),
    // onColumnPinned: (params) =>
    //   savingColumnState(params, PORTFOLIO_COLUMN_STATE_KEY),
    getContextMenuItems: (params) => {
      if (
        params.column?.getColDef().colId === "externalCheckbox"
        // && authDetail.features.includes(FEATURE_KEY.PORTFOLIO_ACCOUNT_TEAM)
      )
        return getCheckboxContextMenu(params, authDetail, "portfolio_only");
      return getContextMenu(params);
    },
    getMainMenuItems: (params) => {
      return getMainMenuItems(params);
    },
    // getChildCount: function (data) {
    //   return data?.count || 0;
    // },
    onCellValueChanged: (event) => {
      const colIds = ["escalationEnggName"];
      if (colIds.some((i) => i === event.column.getColId())) {
        const cellEdditedValue =
          event.newValue !== null && event.newValue !== undefined
            ? event.newValue.trim()
            : event.newValue;
        const oldCellValue =
          event.oldValue !== null && event.oldValue !== undefined
            ? event.oldValue.trim()
            : event.oldValue;
        if (cellEdditedValue !== oldCellValue) {
          const postData = {
            [event.column.getColId()]: cellEdditedValue,
          };
          const url = `/api/dataservice/v1/accounts/${event.data.accountId}/operation-contact`;
          axios.put(url, postData).catch((e) => {
            toast.error(e?.response?.data?.message || "Fail to update", {
              position: "top-center",
              autoClose: 2000,
            });
          });
        }
      }
    },
    onRowSelected: (e: RowSelectedEvent) => {
      const savedSelect = sessionStorage.getItem(PRE_SELECTED_ACCOUNT);
      if (e.node.isSelected()) {
        if (preSelected?.filter((id) => id === e.data.accountKey)?.length) {
          return;
        } else {
          if (savedSelect) {
            const localSelect = JSON.parse(savedSelect);
            const data = [
              ...localSelect,
              {
                accountId: e.data.accountId,
                accountKey: e.data.accountKey,
                accountName: e.data.accountName,
                csmInfo: {
                  accountKey: e.data.accountKey,
                  name: e.data.ciscoCsmName,
                  cecId: e.data.ciscoCsmId,
                },
                videoDeviceCloudAmount3Y: e.data.videoDeviceCloudAmount3Y,
                videoDeviceNonCloudAmount3Y: e.data.videoDeviceNonCloudAmount3Y,
              },
            ];
            const newData: any = [];
            data.map((i) => {
              newData.push({ accountKey: i.accountKey });
            });
            sessionStorage.setItem(PRE_SELECTED_ACCOUNT, JSON.stringify(newData));
            setTotalSelect?.(data);
          } else {
            const data = [
              {
                accountId: e.data.accountId,
                accountKey: e.data.accountKey,
                accountName: e.data.accountName,
                csmInfo: {
                  accountKey: e.data.accountKey,
                  name: e.data.ciscoCsmName,
                  cecId: e.data.ciscoCsmId,
                },
                videoDeviceCloudAmount3Y: e.data.videoDeviceCloudAmount3Y,
                videoDeviceNonCloudAmount3Y: e.data.videoDeviceNonCloudAmount3Y,
              },
            ];
            setTotalSelect?.(data);
            const newData: any = [];
            data.map((i) => {
              newData.push({ accountKey: i.accountKey });
            });
            sessionStorage.setItem(PRE_SELECTED_ACCOUNT, JSON.stringify(newData));
          }
        }
      } else {
        if (savedSelect) {
          const localSelect = JSON.parse(savedSelect);
          const data = localSelect.filter((x: SelectAccount) => x.accountKey !== e.data.accountKey);
          const newData: any = [];
          data.map((i: any) => {
            newData.push({ accountKey: i.accountKey });
          });
          sessionStorage.setItem(PRE_SELECTED_ACCOUNT, JSON.stringify(newData));
          setTotalSelect?.(data);
        }
      }
    },
    onSelectionChanged: (e: RowSelectedEvent) => {
      const savedSelect = sessionStorage.getItem(PRE_SELECTED_ACCOUNT);
      // select current account forever & saved in local
      const curAccount = e.api?.getRowNode(fixedAccountId as string);
      if (curAccount) {
        curAccount.setSelected(true);
        const data = [
          {
            accountId: curAccount.data.accountId,
            accountKey: curAccount.data.accountKey,
            accountName: curAccount.data.accountName,
            csmInfo: {
              accountKey: curAccount.data.accountKey,
              name: curAccount.data.ciscoCsmName,
              cecId: curAccount.data.ciscoCsmId,
            },
            videoDeviceCloudAmount3Y: curAccount.data.videoDeviceCloudAmount3Y,
            videoDeviceNonCloudAmount3Y: curAccount.data.videoDeviceNonCloudAmount3Y,
          },
        ];

        if (savedSelect) {
          const localSelect = JSON.parse(savedSelect);
          const newSelect = [
            ...localSelect.filter((i: any) => i.accountKey !== fixedAccountId),
            ...data,
          ];
          setTotalSelect?.(newSelect);
          const newData: any = [];
          newSelect.map((i) => {
            newData.push({ accountKey: i.accountKey });
          });
          sessionStorage.setItem(PRE_SELECTED_ACCOUNT, JSON.stringify(newData));
        } else {
          setTotalSelect?.(data);
          const newData: any = [];
          data.map((i) => {
            newData.push({ accountKey: i.accountKey });
          });
          sessionStorage.setItem(PRE_SELECTED_ACCOUNT, JSON.stringify(newData));
        }
      }
    },
    noRowsOverlayComponent: "NoRowsOverlayComponent",
    rowModelType: "serverSide",
    cacheBlockSize: 1000,
    //change row buffer to 20 for bug WXCSENG-6608
    rowBuffer: 20,
    maxBlocksInCache: 1000, // for columnOrderHidePreference purposes
    cacheOverflowSize: 1,
    blockLoadDebounceMillis: 500,
    maxConcurrentDatasourceRequests: 10,
    allowDragFromColumnsToolPanel: true,
    suppressPropertyNamesCheck: true,
    enableCellChangeFlash: false,
    groupMultiAutoColumn: true,
    groupUseEntireRow: true,
    // animateRows: true,
    getRowNodeId: (data: any) => data.groupId || data.groupName || data.accountKey,
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressSideButtons: true,
            // suppressColumnFilter: true,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
            suppressSyncLayoutWithGrid: true,
          },
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          toolPanelParams: {
            suppressSyncLayoutWithGrid: true,
            // suppressFilterSearch: true,
          },
        },
        {
          id: "saveSearchPanel",
          labelDefault: "Saved Searches",
          labelKey: "saveSearchPanel",
          iconKey: "columns",
          toolPanel: "SaveSearchPanel",
          toolPanelParams: {
            pageId: "portfolio",
          },
        },
      ],
    },
    rowClassRules: {
      "inactive-account": (params) => (params.data?.accountStatus === "Inactive" ? true : false),
      "new-account": (params) => (params.data?.new ? true : false),
      "hover-show-container": () => true,
    },
    frameworkComponents: {
      NumberFilter,
      // AccountNameRenderer,
      AccountTypeRenderer,
      SiteURLsRenderer,
      ExpandPlanRenderer,
      CountryRenderer,
      ContactsRenderer,
      TagsRenderer,
      CheckboxFilter,
      CheckboxTreeFilter,
      ExpandPlanFilter,
      DatePickerFilter,
      CompetitorRenderer,
      HealthScoreRenderer,
      SaveSearchPanel,
      CheckboxHeader,
      PartnerAccountNameFilter,
      QuaterViewReviewFilter,
      AccountIdRenderer,
      CheckboxCellRenderer,
      NoRowsOverlayComponent,
      AROffPendingCancelRenderer,
      RadioFilter,
      InvoiceMrrArrRenderer,
      HighlightFilterModelCellRenderer,
      CCSECellEditor,
      EditableCellRenderer,
      CollabMapRenderer,
      CollabMapFilter,
      ConciergeFilter,
      ConciergeRenderer,
      ComonAccountNameRender,
      CollectionRevenueCellRenderer,
      CollectionRevenueCellHeader,
      StaticCollectionRevenueCellRenderer,
      CallingEpsmCellEditor,
      CIOrganizationIDRenderer,
      AlertRenderer,
      OrganizationInvoiceArrCellRenderer,
      QVRRenderer,
      CoverageStatusRenderer,
      ActivityAlreadyRenderer,
      BetaProgramRenderer,
      BetaProgramFilter,
      AnchorProductRenderer,
      ChConfigStatusRenderer,
      CustomTooltipHeader,
      ProductRenderer,
      ProductServiceFilter,
      DeviceFilter,
      PercentFilter,
      EscalationRenderer,
      GroupRenderer,
      ReasonRenderer,
      ResellerFilter,
      WSMPStatusRenderer,
      WorkloadFilter,
      SubscriptionRenderer,
    },
  };
};
export default Config;
